import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetESICALLAction,
  SetActiveTabs,
  SetESIEditCALLAction,
  SetESICraeteCALLAction,
  settheDataFetchActions, //--data---fetch---
  SetSignaturePops, //=------sign
  setThecreateEmploSigAction, //---post
  setTheActionForOtpPhoneNumbers, ///----Phone---Number----
  setTheActionForOtpwithPhoneNumbers, ///---Phone Number ---With the Otp
  Files,
  setFamilyEmpDataActions,
  setTheSignaturePadNumberSet, /////set The SignaturePad
  SetApprovalCallsActions,
  SetEmployeeProfileDetailsID,
} from "../../../Redux/Slice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import { max, min } from "date-fns";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import { PresentUrl } from "../../../text/apidata";
import axios from "axios";
import { store } from "../../../Redux/Store";
import { Downloads_doc } from "./Downloads_doc";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const ESIfrom = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const formdatas = new FormData();
  const Swal = require("sweetalert2");
  const [PhonerNumber, setPhoneNumber] = useState();
  const [createEmployee, setCreateEmployee] = useState();
  const [Approvel, setApprovel] = useState(false);

  const [SubRoleList, setSubRoleList] = useState();
  const [Bank, setBank] = useState(false);

  const [idverificationsID, setdVerifications] = useState(false);
  const [ErroIndex, setErrInde] = useState(0);
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
  const [nomiessval, setSecondNomiee] = useState("");
  const OptionsForNomiees = [
    { value: "0", label: "0" },
    { value: "25", label: "25" },
    { value: "50", label: "50" },
    { value: "75", label: "75" },
    { value: "100", label: "100" },
  ];
  const [selected, setSelectal] = useState([]);
  const [newValuesSecn, setnewValuesSec] = useState();
  const OptionsFam = [
    {
      value: 1,
      label: "FATHER",
    },
    {
      value: 2,
      label: "MOTHER",
    },
    {
      value: 3,
      label: "SPOUSE",
    },
    {
      value: 4,
      label: "SON",
    },
    {
      value: 5,
      label: "DAUGHTER",
    },
    {
      value: 6,
      label: "GUARDIAN",
    },
  ];
  const [FamilyOptions, setFamilyOptions] = useState(OptionsFam);
  const [NomieeFirst, setnomieeFirst] = useState();
  const [Nomieesecond, setnomieesecond] = useState();

  const [SecondNomieesoptions, setsecondNomiee] = useState(false);
  const [secondnomie, setsecondnomie] = useState(false);
  const [Numberoffields, setNumberOfFileds] = useState(1);
  useEffect(() => {
    if (
      state.FormsIDList.ESIFormsid != "" &&
      state.FormsIDList.ActiveTabs == 9
    ) {
      const payload = {
        Retieveid: state.FormsIDList.ESIFormsid,
      };

      dispatch(SetESICALLAction(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);
  //console.log(state.ESIdetails.ESIDATAS, "employssdg");
  const initialState = {
    employee_name: "",
    marital_status: "unmarried",
    father_husband_name: "",
    gender: "",
    date_of_joining: "",
    e_p_f: "",
    e_p_s: "",
    date_of_birth: "",
    address_temporary: "",
    address_permanent: "",
    account_number: "",
    total_amount: "",
    timeline_id: state.BasicFormCreated.BasciFormCreate,
    esi_dispensary: "",
    NameOfFamliy: "husband",
    FatherORHUSBANDNAME: "",
    FatherName: "",
    HusbandName: "",
    previous_ESI_number: "",

    NameOfNomiees: "",
    secondNomiees: "",
    AddressOf_nomoiees: "",
    AddressOf_second_nomoiee: "",
    percentage: "",
    nominee_relationship: "",
    nominee_name_address: "",
    nominee_dob: "",
    if_nominee_minor: "",
    //--second
    second_if_nominee_minor: null,
    second_nominee_dob: null,
    second_nominee_name_address: null,
    second_nominee_relationship: null,
    second_percentage: null,
    second_total_amount: "",
    ///third
    third_if_nominee_minor: null,
    third_nominee_dob: null,
    third_nominee_name_address: null,
    third_nominee_relationship: null,
    third_percentage: null,
    third_total_amount: null,
    NameofthidNomirr: "",
    addressofthirdnomiee: "",
    //--four
    fourth_if_nominee_minor: null,
    fourth_nominee_dob: null,
    fourth_nominee_name_address: null,
    fourth_nominee_relationship: null,
    fourth_percentage: null,
    fourth_total_amount: null,
    NameoffourthNomirr: "",
    addressoffourthnomiee: "",

    nominee_image: "",
    second_nominee_image: "",
    third_nominee_image: "",
    fourth_nominee_image: "",
  };

  const [data, setData] = useState(initialState);
  const [empNameerr, setEmpNaErr] = useState("");
  const [maritalStErr, setMatriErr] = useState("");
  const [FaNErr, setFaErr] = useState("");
  const [GenderErr, setGenderErr] = useState("");
  const [DateJErr, setDateErr] = useState("");
  const [EpfErr, setEpFErr] = useState("");
  const [EpsERR, setEpsErr] = useState("");
  const [dateBErr, setDateBErr] = useState("");
  const [AddressTEMPOERR, setAddretemErr] = useState("");
  const [AddressPerErr, setAddressPerErr] = useState("");
  const [AccounNumberErr, setAccountErr] = useState("");
  const [TotalNumErr, setTotalErr] = useState("");
  const [NomieeErr, setNoimerr] = useState("");
  const [nomierN, setnoimeerr] = useState("");
  const [noimeeDobErr, setnoimeeDobErr] = useState("");
  const [ifNoimeeErr, setIfnoimeeErr] = useState("");
  const [count, setcount] = useState(1);
  const [creaetStat, setCreateSt] = useState(false);
  const [totalAmountSelect, setTotalAmount] = useState([]);
  const [TotalNomiees, setTotalNomiees] = useState();
  const [NameOfRelations, setNameOfRelations] = useState([]);
  const [whatsApp, setWhatsApp] = useState(false);
  const [NomieerrSelctErr, setnoimeeErr] = useState("");
  const [EmailID, setEmailID] = useState("");
  const UserData = useSelector((state) => state.users.UserData.data);
  const [PasChec, setPassChe] = useState({ Father: true, husband: false });
  const [previosueEsi, setpreviousESi] = useState("");
  const [FatherErr, setFatherErr] = useState("");
  const [secondNomieesErr, setsecondNomieesError] = useState("");
  const [AddressOf_second_nomoieeError, SetAddressOf_second_nomoieeError] =
    useState("");
  const [SecondRelationError, setRelationError] = useState("");
  const [second_nominee_dobError, setsecond_nominee_dobError] = useState("");
  const [ifsecondError, setIfsecondErro] = useState("");
  const [SecondNomieeTotal, setSecondNomieTotal] = useState("");
  const [NomieeeImageurl, setNomieeImageUrl] = useState("");
  const [NomieeeSecondImageurl, setNomieeSecondImageUrl] = useState("");
  const [NomieeeThirdImageurl, setNomieeThirdImageUrl] = useState("");
  const [NomieeeFourImageurl, setNomieeFourImageUrl] = useState("");

  const [NomieeeImageError, setNomieeImageError] = useState(null);
  const [NomieeeSecondImageError, setNomieeSecondImageError] = useState(null);
  const [NomieeeThirdImageError, setNomieeThirdImageError] = useState(null);
  const [NomieeeFourImageError, setNomieeFourImageError] = useState(null);

  // For the third nominee
  const [thirdNomineesErr, setThirdNomineesError] = useState("");
  const [AddressOf_third_nomineeError, setAddressOf_third_nomineeError] =
    useState("");
  const [ThirdRelationError, setThirdRelationError] = useState("");
  const [ifThirdTotalError, setIfThirdTotalError] = useState("");

  const [third_nominee_dobError, setThird_nominee_dobError] = useState("");
  const [ifThirdError, setIfThirdError] = useState("");

  // For the fourth nominee
  const [fourthNomineesErr, setFourthNomineesError] = useState("");
  const [AddressOf_fourth_nomineeError, setAddressOf_fourth_nomineeError] =
    useState("");
  const [FourthRelationError, setFourthRelationError] = useState("");
  const [FourthTotalError, setFourthTotalError] = useState("");

  const [fourth_nominee_dobError, setFourth_nominee_dobError] = useState("");
  const [ifFourthError, setIfFourthError] = useState("");
  const Options = [
    {
      // id: 1,

      value: "unmarried",
      label: "UNMARRIED",
    },
    {
      // id: 2,
      value: "married",
      label: "MARRIED",
    },
    {
      // id: 3,
      value: "others",
      label: "OTHERS",
    },
  ];

  const [MaterilStatus, setMaritalStatus] = useState({
    // id: 1,

    value: "unmarried",
    label: "UNMARRIED",
  });
  //--percentanges
  //'---third ---noieee---
  const [ThirdNomieeOptions, setThirdNomieeOpt] = useState();
  ///--fourth
  const [fourtheNomie, setFourthenomiee] = useState();
  //---family details
  //'---third ---noieee---
  const [ThirdNomieeFamOptions, setThirdNomieeOptFam] = useState();
  ///--fourth
  const [fourtheNomieFam, setFourthenomieeFam] = useState();

  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [forindex, setforindex] = useState();
  const [imgsrc, setImgsrc] = useState();
  const [alert, setalert] = useState(false);
  const [Educatiobnfiles, setEducationFiles] = useState();
  const [images, setImages] = useState([null, null, null, null, null, null]);
  const [Presentimages, setPresentImages] = useState([
    null,
    null,
    null,
    null,
    null,
  ]);

  const [imagesFile, setImagesFile] = useState([null, null, null, null, null]);

  const [PresentUrls, setPresentUrls] = useState([]);

  const [updatedst, setupdatest] = useState();
  const fileInputRef = useRef();

  const [imageFileChange, setImageFileChange] = useState([
    false,
    false,
    false,
    false,
  ]);
  const [updateImage, setUpdateImage] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);

  ////--Error --messasge

  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
  };

  useEffect(() => {
    dispatch(setTheSignaturePadNumberSet(0));
  }, []);

  useEffect(() => {
    if (
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
      state.ESICreatedetails.ESICreateDATAS != undefined &&
      state.FormsIDList.ESIFormsid != "" &&
      state.EmployeeProfile.EmployeeProfileList.is_declaration_form &&
      state.EmployeeProfile.EmployeeProfileList.is_basic_info &&
      state.EmployeeProfile.EmployeeProfileList.is_esi_form &&
      // state.EmployeeProfile.EmployeeProfileList.is_id_verification &&
      state.EmployeeProfile.EmployeeProfileList.is_previous_employee &&
      state.EmployeeProfile.EmployeeProfileList.is_education_details &&
      state.EmployeeProfile.EmployeeProfileList.is_job_description &&
      state.EmployeeProfile.EmployeeProfileList.is_address_details &&
      state.EmployeeProfile.EmployeeProfileList.is_bank_details &&
      !state.EmployeeProfile.EmployeeProfileList.create_employee
    ) {
      setCreateSt(true);
    }
    // console.log(state.EmployeeProfile.EmployeeProfileList , "o82quwidx");
  }, [
    state.ESICreatedetails.ESICreateDATAS,
    state.FormsIDList.ESIFormsid,
    count,
    state.ESIdetails.ESIDATAS,
    state.EmployeeProfile.EmployeeProfileList,
  ]);

  const preventTyping = (e) => {
    const invalidKey =
      (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) || // Any printable character
      e.key === " " || // Space key
      e.key === "Tab" || // Tab key
      e.key === "Enter"; // Enter key

    if (invalidKey) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    if (
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.ClientBranchIDs.EmployeeDetailsProfile != ""
    ) {
      if (
        state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
        state.ClientBranchIDs.EmployeeDetailsProfile.create_employee != null &&
        state.ClientBranchIDs.EmployeeDetailsProfile.create_employee !=
          undefined
      ) {
        setApprovel(true);
      }
      if (
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
        state.ClientBranchIDs.EmployeeDetailsProfile.job_description !=
          undefined &&
        state.ClientBranchIDs.EmployeeDetailsProfile.job_description != null &&
        state.ClientBranchIDs.EmployeeDetailsProfile.job_description
          .joining_date == null
      ) {
        ///--if--its--null --make it as false
        setCreateEmployee(false);
      }

      if (
        state.NumberCounts.Editable == 1 &&
        state.FormsIDList.ESIFormsid != "" &&
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList.is_id_verification != null &&
        state.EmployeeProfile.EmployeeProfileList.is_id_verification !=
          undefined
      ) {
        setdVerifications(
          state.EmployeeProfile.EmployeeProfileList.is_id_verification,
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_bank_details != null &&
        state.EmployeeProfile.EmployeeProfileList.is_bank_details != undefined
      ) {
        setBank(state.EmployeeProfile.EmployeeProfileList.is_bank_details);
        // setWhatsApp(true);
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.create_employee != null &&
        state.EmployeeProfile.EmployeeProfileList.create_employee != undefined
      ) {
        setCreateEmployee(
          state.EmployeeProfile.EmployeeProfileList.create_employee,
        );
      }
      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        !state.EmployeeProfile.EmployeeProfileList.is_pending &&
        !state.EmployeeProfile.EmployeeProfileList.is_pending &&
        state.EmployeeProfile.EmployeeProfileList.job_description !=
          undefined &&
        state.EmployeeProfile.EmployeeProfileList.job_description != null &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
          null &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
          undefined
      ) {
        setApprovel(true);
      } else {
        setApprovel(false);
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.whatsapp_verify != null &&
        state.EmployeeProfile.EmployeeProfileList.whatsapp_verify != undefined
      ) {
        setWhatsApp(state.EmployeeProfile.EmployeeProfileList.whatsapp_verify);
        // setWhatsApp(true);
      }
    }
    // console.log(
    //   BankDetail,
    //   "jljl",
    //   state.EmployeeProfile.EmployeeProfileList.id
    // );
  }, [state.EmployeeProfile.EmployeeProfileList]);

  const GenderList = {
    Male: false,
    Female: false,
    other: false,
  };

  useEffect(() => {
    if (UserData != undefined) {
      if (
        UserData.admin_access != undefined &&
        UserData.admin_access != "" &&
        UserData.admin_access != null &&
        UserData.admin_access != undefined
      ) {
        setEmailID(UserData.email);
      }
    }
  }, [state.users.UserData.data]);

  const HandleChanges = (e) => {
    console.log(e.target.name, "sfoashdoqwdsa", e.target.value);
    if (e.target.name == "gender") {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value,
      });
    }

    if (e.target.name == "marital_status") {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value,
      });
    } else if (e.target.name != "marital_status" && e.target.name != "gender") {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value.toUpperCase(),
      });
    }
  };

  const [StatusCode, setStatusCode] = useState(false);
  ///---rendring the useEffect to find the status
  useEffect(() => {
    if (
      state.ManPowerActiveDataTabs.statusCOdeForESign != undefined &&
      state.ManPowerActiveDataTabs.statusCOdeForESign != null &&
      state.ManPowerActiveDataTabs.statusCOdeForESign == 200
    ) {
      setStatusCode(true);
    } else {
      setStatusCode(false);
    }
  }, [state.ManPowerActiveDataTabs.statusCOdeForESign]);

  //---total---amount--selects
  const HandleTotalAmounts = (e, Numbers) => {
    // const newValues = e.value.replace("%", "");
    const newValues = e.value;
    const SecondNomiees = 100 - Number(newValues);
    const Nomiees = 100 - Number(newValues);
    console.log(newValues, "0932810sjdlkasjd");

    if (Numbers == 0) {
      if (e != null && newValues != 100) {
        setData({
          ...data,
          percentage: newValues == 100 ? 100 : e.label,
          total_amount: newValues,
        });
      }

      if (newValues == 100) {
        // Swal.fire({
        //   title: "Are you sure you want to give the total percentage to the first Nominee? By doing so, the other nominees will be removed from the list by default",
        //   icon: "info",
        //   timer: 3000, // Popup will close after 3 seconds
        //   timerProgressBar: true,
        //   confirmButtonColor: "#234492",
        //   cancelButtonColor: "#6c757d",
        //   didClose: () => {
        //     setData({
        //       ...data,
        //       second_total_amount: "",
        //       second_nominee_name_address: "",
        //       second_nominee_relationship: "",
        //       second_if_nominee_minor: "",
        //       second_nominee_dob: "",
        //       secondNomiees: "",
        //       total_amount: 100,
        //       percentage: 100,
        //     });

        //     handleRemoveFields(e);
        //     setsecondNomiee(false);
        //   },
        // });
        // setThirdNomieeOpt

        // setFourthenomiee
        setData({
          ...data,
          second_total_amount: 0,
          total_amount: 100,
          percentage: 100,
          third_total_amount: 0,
          third_percentage: 0,
          fourth_percentage: 0,
          fourth_total_amount: 0,
          second_percentage: 0,
        });
        setTotalNomiees(OptionsForNomiees[0]);
        setThirdNomieeOpt(OptionsForNomiees[0]);
        setFourthenomiee(OptionsForNomiees[0]);
      }
    } else if (Numbers == 1) {
      if (e != null && newValues != 100) {
        setTotalNomiees({ value: newValues, label: newValues });

        setData({
          ...data,

          second_total_amount: newValues,
          // total_amount: 0,
          second_percentage: e.label,
        });
      }

      if (newValues == 100) {
        setTotalNomiees({ value: newValues, label: newValues });
        setTotalAmount(OptionsForNomiees[0]);
        setThirdNomieeOpt(OptionsForNomiees[0]);
        setFourthenomiee(OptionsForNomiees[0]);
        setData({
          ...data,
          second_total_amount: newValues,
          total_amount: 0,
          percentage: 0,
          third_total_amount: 0,
          third_percentage: 0,
          fourth_percentage: 0,
          fourth_total_amount: 0,
          second_percentage: e.label,
        });
      }
    } else if (Numbers == 2) {
      if (e != null && newValues != 100) {
        setThirdNomieeOpt({ value: newValues, label: newValues });

        setData({
          ...data,
          third_percentage: newValues == 100 ? 100 : e.label,
          third_total_amount: newValues,
        });
      }

      if (newValues == 100) {
        setThirdNomieeOpt({ value: newValues, label: newValues });

        setFourthenomiee(OptionsForNomiees[0]);
        setTotalNomiees(OptionsForNomiees[0]);
        setTotalAmount(OptionsForNomiees[0]);

        setData({
          ...data,
          second_total_amount: 0,
          total_amount: 0,
          percentage: 0,
          third_total_amount: newValues,
          third_percentage: e.label,
          fourth_percentage: 0,
          fourth_total_amount: 0,
          second_percentage: 0,
        });
      }
    } else if (Numbers == 3) {
      if (e != null && newValues != 100) {
        setFourthenomiee({ value: newValues, label: newValues });

        setData({
          ...data,
          fourth_percentage: newValues == 100 ? 100 : e.label,
          fourth_total_amount: newValues,
        });
      }

      if (newValues == 100) {
        setFourthenomiee({ value: newValues, label: newValues });
        setThirdNomieeOpt(OptionsForNomiees[0]);
        setTotalNomiees(OptionsForNomiees[0]);
        setTotalAmount(OptionsForNomiees[0]);

        setData({
          ...data,
          second_total_amount: 0,
          total_amount: 0,
          percentage: 0,
          third_total_amount: 0,
          third_percentage: 0,
          fourth_percentage: e.label,
          fourth_total_amount: newValues,
          second_percentage: 0,
        });
      }
    }
  };

  const [dataHold, setDataHold] = useState([]);

  var PushedValues = [];

  ///---Members---For----Selected Nomiees ------
  var ListOfItems = NameOfRelations;

  const handleRemoveFields = (e) => {
    const IndexBasedRomeve = [];
    const NewState = NameOfRelations.filter((item, index) => index !== 1);
    setNameOfRelations(NewState);
  };

  let currentDate = new Date();
  let year = currentDate.getFullYear();

  let endOfYear = new Date(year, 11, 31);
  // let maxDate = new Date();
  // maxDate.setDate(currentDate.getDate() + 30);

  // let minDate = new Date();
  // minDate.setDate(currentDate.getDate() - 30);

  // function formatDate(date) {
  //   let month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() is zero-based
  //   let day = date.getDate().toString().padStart(2, "0");
  //   return `${date.getFullYear()}-${month}-${day}`;
  // }

  // ✅ Employee created date
  const createdAt = state.NumberCounts.Employee_created_date; // e.g. "2025-11-03T14:04:22.818601"

  // ✅ Convert it to a JS Date object
  const createdDate = new Date(createdAt);

  // // ✅ Format helper
  // function formatDate(date) {
  //   let month = (date.getMonth() + 1).toString().padStart(2, "0");
  //   let day = date.getDate().toString().padStart(2, "0");
  //   return `${date.getFullYear()}-${month}-${day}`;
  // }

  // // ✅ Calculate the allowed range
  // let minDate = new Date(createdDate); // same as created date
  // let maxDate = new Date(createdDate);
  // maxDate.setDate(createdDate.getDate() + 3); // allow next 3 days

  function formatDate(date) {
    let month = (date.getMonth() + 1).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
  }
  let currentDateJoin = new Date();

  let minDate = new Date(currentDateJoin);
  minDate.setDate(currentDateJoin.getDate() - 4);

  let maxDate = new Date(currentDateJoin);
  maxDate.setDate(currentDateJoin.getDate() + 2); // ✅ allow 3 total days (created + next 2)

  // ✅ Format both
  let formattedMinDate = formatDate(minDate);
  let formattedMaxDate = formatDate(maxDate);

  const [inputFields, setInputFields] = useState({
    InputFieldsNum: [],
  });

  const handleRemoveFields1 = (e) => {
    const NewState = [...NameOfRelations];
    NewState.splice(0, 1);
    setNameOfRelations(NewState);
  };

  const [ForGender, SetGender] = useState(GenderList);

  useEffect(() => {
    if (
      state.FormsIDList.ESIFormsid != "" &&
      state.ESIdetails.ESIDATAS.id != undefined &&
      state.FormsIDList.ESIFormsid == state.ESIdetails.ESIDATAS.id &&
      state.FormsIDList.ESIFormsid != ""
    ) {
      const parts =
        state.ESIdetails.ESIDATAS.nominee_name_address != null &&
        state.ESIdetails.ESIDATAS.nominee_name_address != "" &&
        state.ESIdetails.ESIDATAS.nominee_name_address.split(/[@#]+/);

      const parts1 =
        state.ESIdetails.ESIDATAS.second_nominee_name_address != null &&
        state.ESIdetails.ESIDATAS.second_nominee_name_address != "" &&
        state.ESIdetails.ESIDATAS.second_nominee_name_address.split(/[@#]+/);

      const fatherorhusband =
        state.ESIdetails.ESIDATAS.father_husband_name != null &&
        state.ESIdetails.ESIDATAS.father_husband_name != "" &&
        state.ESIdetails.ESIDATAS.father_husband_name.split(/[@#]+/);

      const separator = ", "; // Define the separator
      const joinedStrings =
        parts != undefined && parts != "" && parts.join(separator); // Join the array into a single string using the separator variable
      // console.log(joinedStrings, "joinedStrings-");

      const joinedStrings2 =
        parts1 != undefined && parts1 != "" && parts1.join(separator);
      const joinedString =
        parts != undefined &&
        parts != "" &&
        parts.length > 2 &&
        parts.join(" "); //
      const joingString1 =
        parts1 != undefined &&
        parts1 != "" &&
        parts1.length > 2 &&
        parts1.join("");

      const NameFathHusband =
        fatherorhusband != undefined &&
        fatherorhusband != "" &&
        fatherorhusband.length > 2 &&
        fatherorhusband.join("");

      const ThirdNomiee =
        state.ESIdetails.ESIDATAS.third_nominee_name_address != null &&
        state.ESIdetails.ESIDATAS.third_nominee_name_address != "" &&
        state.ESIdetails.ESIDATAS.third_nominee_name_address.split(/[@#]+/);

      const fourthNomiee =
        state.ESIdetails.ESIDATAS.fourth_nominee_name_address != null &&
        state.ESIdetails.ESIDATAS.fourth_nominee_name_address != "" &&
        state.ESIdetails.ESIDATAS.fourth_nominee_name_address.split(/[@#]+/);

      if (fatherorhusband[1] != undefined && fatherorhusband[1]) {
        setPassChe({
          ...PasChec,
          Father: fatherorhusband[1] == "father" ? true : false,
          husband: fatherorhusband[1] == "husband" ? true : false,
        });
      } else if (fatherorhusband[1] == undefined || !fatherorhusband[1]) {
        setPassChe({
          ...PasChec,
          Father: false,
          husband: true,
        });
      }
      console.log(joingString1, "joingString1");

      const cleanValue = (val) => {
        if (typeof val === "string" && val.startsWith("null")) {
          return val.replace(/^null/, ""); // Remove only the first occurrence at start
        }
        return val;
      };

      setData({
        ...data,
        employee_name: state.ESIdetails.ESIDATAS.employee_name,
        marital_status: state.ESIdetails.ESIDATAS.marital_status,
        father_husband_name: state.ESIdetails.ESIDATAS.father_husband_name,
        date_of_joining: state.ESIdetails.ESIDATAS.date_of_joining,
        gender: state.ESIdetails.ESIDATAS.gender,
        date_of_birth: state.ESIdetails.ESIDATAS.date_of_birth,
        e_p_f: state.ESIdetails.ESIDATAS.e_p_f,
        e_p_s: state.ESIdetails.ESIDATAS.e_p_s,
        address_temporary: state.ESIdetails.ESIDATAS.address_temporary,
        address_permanent: state.ESIdetails.ESIDATAS.address_permanent,
        account_number: state.ESIdetails.ESIDATAS.account_number,

        nominee_relationship: state.ESIdetails.ESIDATAS.nominee_relationship,
        percentage:
          state.ESIdetails.ESIDATAS.percentage != null ||
          state.ESIdetails.ESIDATAS.percentage == undefined
            ? state.ESIdetails.ESIDATAS.percentage
            : "",
        total_amount:
          state.ESIdetails.ESIDATAS.percentage != null ||
          state.ESIdetails.ESIDATAS.percentage == undefined
            ? state.ESIdetails.ESIDATAS.percentage
            : "",
        esi_dispensary: state.ESIdetails.ESIDATAS.esi_dispensary,
        // nominee_name_address: state.ESIdetails.ESIDATAS.nominee_name_address,
        NameOfNomiees: parts[0] != undefined ? parts[0] : "",
        AddressOf_nomoiees: parts[1] != undefined ? parts[1] : "",

        secondNomiees: parts1[0] != undefined ? parts1[0] : "",
        AddressOf_second_nomoiee: parts1[1] != undefined ? parts1[1] : "",

        nominee_name_address: joinedString,

        nominee_dob:
          state.ESIdetails.ESIDATAS.nominee_dob == null
            ? ""
            : state.ESIdetails.ESIDATAS.nominee_dob,
        if_nominee_minor: state.ESIdetails.ESIDATAS.if_nominee_minor,
        second_if_nominee_minor:
          state.ESIdetails.ESIDATAS.second_if_nominee_minor == null
            ? null
            : state.ESIdetails.ESIDATAS.second_if_nominee_minor,
        second_nominee_dob:
          state.ESIdetails.ESIDATAS.second_nominee_dob == null
            ? null
            : state.ESIdetails.ESIDATAS.second_nominee_dob,
        second_nominee_name_address: joingString1,
        second_nominee_relationship:
          state.ESIdetails.ESIDATAS.second_nominee_relationship == null
            ? null
            : state.ESIdetails.ESIDATAS.second_nominee_relationship,
        second_percentage: state.ESIdetails.ESIDATAS.second_percentage,
        second_total_amount: state.ESIdetails.ESIDATAS.second_percentage,
        FatherORHUSBANDNAME:
          fatherorhusband[1] != undefined && fatherorhusband[1] == "husband"
            ? fatherorhusband[0]
            : "",
        FatherName:
          fatherorhusband[1] != undefined && fatherorhusband[1] == "father"
            ? fatherorhusband[0]
            : "",
        NameOfFamliy:
          fatherorhusband[1] != undefined ? fatherorhusband[1] : "husband",
        previous_ESI_number: state.ESIdetails.ESIDATAS.previous_ESI_number,

        third_if_nominee_minor:
          state.ESIdetails.ESIDATAS.third_if_nominee_minor,
        third_nominee_dob: state.ESIdetails.ESIDATAS.third_nominee_dob,
        third_nominee_name_address: cleanValue(
          state.ESIdetails.ESIDATAS.third_nominee_name_address,
        ),
        third_nominee_relationship:
          state.ESIdetails.ESIDATAS.third_nominee_relationship,
        third_percentage: state.ESIdetails.ESIDATAS.third_percentage,
        third_total_amount: state.ESIdetails.ESIDATAS.third_percentage,
        NameofthidNomirr: ThirdNomiee[0] != undefined ? ThirdNomiee[0] : "",
        addressofthirdnomiee: ThirdNomiee[1] != undefined ? ThirdNomiee[1] : "",

        //--four
        fourth_if_nominee_minor:
          state.ESIdetails.ESIDATAS.fourth_if_nominee_minor,
        fourth_nominee_dob: state.ESIdetails.ESIDATAS.fourth_nominee_dob,
        fourth_nominee_name_address: cleanValue(
          state.ESIdetails.ESIDATAS.fourth_nominee_name_address,
        ),
        fourth_nominee_relationship:
          state.ESIdetails.ESIDATAS.fourth_nominee_relationship,
        fourth_percentage: state.ESIdetails.ESIDATAS.fourth_percentage,
        fourth_total_amount: state.ESIdetails.ESIDATAS.fourth_percentage,
        NameoffourthNomirr: fourthNomiee[0] != undefined ? fourthNomiee[0] : "",
        addressoffourthnomiee:
          fourthNomiee[1] != undefined ? fourthNomiee[1] : "",
        nominee_image: state.ESIdetails.ESIDATAS.nominee_image,
        second_nominee_image: state.ESIdetails.ESIDATAS.second_nominee_image,
        third_nominee_image: state.ESIdetails.ESIDATAS.third_nominee_image,
        fourth_nominee_image: state.ESIdetails.ESIDATAS.fourth_nominee_image,
      });
      // setTotalAmount({
      //   value: state.ESIdetails.ESIDATAS.total_amount,
      //   label: `${state.ESIdetails.ESIDATAS.total_amount}%`,
      // });

      setTotalNomiees({
        value:
          state.ESIdetails.ESIDATAS.second_percentage === "" ||
          state.ESIdetails.ESIDATAS.second_percentage == null
            ? "0"
            : state.ESIdetails.ESIDATAS.second_percentage,
        label: `${state.ESIdetails.ESIDATAS.second_percentage === "" || state.ESIdetails.ESIDATAS.second_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.second_percentage}`}`,
      });

      setTotalAmount({
        value:
          state.ESIdetails.ESIDATAS.percentage === "" ||
          state.ESIdetails.ESIDATAS.percentage == null
            ? "0"
            : state.ESIdetails.ESIDATAS.percentage,
        label: `${state.ESIdetails.ESIDATAS.percentage === "" || state.ESIdetails.ESIDATAS.percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.percentage}`}`,
      });

      setFourthenomiee({
        value:
          state.ESIdetails.ESIDATAS.fourth_percentage === "" ||
          state.ESIdetails.ESIDATAS.fourth_percentage == null
            ? "0"
            : state.ESIdetails.ESIDATAS.fourth_percentage,
        label: `${state.ESIdetails.ESIDATAS.fourth_percentage === "" || state.ESIdetails.ESIDATAS.fourth_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.fourth_percentage}`}`,
      });
      setThirdNomieeOpt({
        value:
          state.ESIdetails.ESIDATAS.third_percentage === "" ||
          state.ESIdetails.ESIDATAS.third_percentage == null
            ? "0"
            : state.ESIdetails.ESIDATAS.third_percentage,
        label: `${state.ESIdetails.ESIDATAS.third_percentage === "" || state.ESIdetails.ESIDATAS.third_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.third_percentage}`}`,
      });
      if (state.ESIdetails.ESIDATAS.percentage == 100) {
        setTotalNomiees({
          value: 0,
          label: `${0}`,
        });

        setFourthenomiee({
          value: 0,
          label: `${0}`,
        });
        setThirdNomieeOpt({
          value: 0,
          label: `${0}`,
        });
      } else if (state.ESIdetails.ESIDATAS.percentage != 100) {
        setTotalNomiees({
          value:
            state.ESIdetails.ESIDATAS.second_percentage === "" ||
            state.ESIdetails.ESIDATAS.second_percentage == null
              ? "0"
              : state.ESIdetails.ESIDATAS.second_percentage,
          label: `${state.ESIdetails.ESIDATAS.second_percentage === "" || state.ESIdetails.ESIDATAS.second_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.second_percentage}`}`,
        });

        setTotalAmount({
          value:
            state.ESIdetails.ESIDATAS.percentage === "" ||
            state.ESIdetails.ESIDATAS.percentage == null
              ? "0"
              : state.ESIdetails.ESIDATAS.percentage,
          label: `${state.ESIdetails.ESIDATAS.percentage === "" || state.ESIdetails.ESIDATAS.percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.percentage}`}`,
        });

        setFourthenomiee({
          value:
            state.ESIdetails.ESIDATAS.fourth_percentage === "" ||
            state.ESIdetails.ESIDATAS.fourth_percentage == null
              ? "0"
              : state.ESIdetails.ESIDATAS.fourth_percentage,
          label: `${state.ESIdetails.ESIDATAS.fourth_percentage === "" || state.ESIdetails.ESIDATAS.fourth_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.fourth_percentage}`}`,
        });
        setThirdNomieeOpt({
          value:
            state.ESIdetails.ESIDATAS.third_percentage === "" ||
            state.ESIdetails.ESIDATAS.third_percentage == null
              ? "0"
              : state.ESIdetails.ESIDATAS.third_percentage,
          label: `${state.ESIdetails.ESIDATAS.third_percentage === "" || state.ESIdetails.ESIDATAS.third_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.third_percentage}`}`,
        });
      } else if (
        state.ESIdetails.ESIDATAS.fourth_percentage != 100 &&
        state.ESIdetails.ESIDATAS.percentage != 100 &&
        state.ESIdetails.ESIDATAS.second_percentage != 100 &&
        state.ESIdetails.ESIDATAS.third_percentage != 100
      ) {
        setTotalNomiees({
          value:
            state.ESIdetails.ESIDATAS.second_percentage === "" ||
            state.ESIdetails.ESIDATAS.second_percentage == null
              ? "0"
              : state.ESIdetails.ESIDATAS.second_percentage,
          label: `${state.ESIdetails.ESIDATAS.second_percentage === "" || state.ESIdetails.ESIDATAS.second_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.second_percentage}`}`,
        });

        setTotalAmount({
          value:
            state.ESIdetails.ESIDATAS.percentage === "" ||
            state.ESIdetails.ESIDATAS.percentage == null
              ? "0"
              : state.ESIdetails.ESIDATAS.percentage,
          label: `${state.ESIdetails.ESIDATAS.percentage === "" || state.ESIdetails.ESIDATAS.percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.percentage}`}`,
        });

        setFourthenomiee({
          value:
            state.ESIdetails.ESIDATAS.fourth_percentage === "" ||
            state.ESIdetails.ESIDATAS.fourth_percentage == null
              ? "0"
              : state.ESIdetails.ESIDATAS.fourth_percentage,
          label: `${state.ESIdetails.ESIDATAS.fourth_percentage === "" || state.ESIdetails.ESIDATAS.fourth_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.fourth_percentage}`}`,
        });
        setThirdNomieeOpt({
          value:
            state.ESIdetails.ESIDATAS.third_percentage === "" ||
            state.ESIdetails.ESIDATAS.third_percentage == null
              ? "0"
              : state.ESIdetails.ESIDATAS.third_percentage,
          label: `${state.ESIdetails.ESIDATAS.third_percentage === "" || state.ESIdetails.ESIDATAS.third_percentage == null ? "0" : `${state.ESIdetails.ESIDATAS.third_percentage}`}`,
        });
      }

      setEpsErr("");

      if (state.ESIdetails.ESIDATAS.marital_status != undefined) {
        setMaritalStatus({
          value: state.ESIdetails.ESIDATAS.marital_status,
          label: state.ESIdetails.ESIDATAS.marital_status.toUpperCase(),
        });
      }

      if (
        state.ESIdetails.ESIDATAS.second_percentage != null &&
        state.ESIdetails.ESIDATAS.second_percentage != "null" &&
        state.ESIdetails.ESIDATAS.second_percentage != undefined &&
        state.ESIdetails.ESIDATAS.second_percentage != ""
      ) {
        setsecondnomie(true);
      }
      // Assuming state.ESIdetails.ESIDATAS.total_amount is "50%"
      if (
        state.ESIdetails.ESIDATAS.percentage != null &&
        state.ESIdetails.ESIDATAS.percentage != "null" &&
        state.ESIdetails.ESIDATAS.percentage != undefined
      ) {
        const totalAmountString = state.ESIdetails.ESIDATAS.total_amount;
        const totalAmountWithoutPercentage = totalAmountString.replace("%", "");

        const totalAmount = parseFloat(totalAmountWithoutPercentage);
        if (!isNaN(totalAmount)) {
          const SecondNominees = 100 - totalAmount;
        } else {
        }
      }

      var updatedRelations = [];
      var updatedSecondRelation = [];
      var UpdatedEsiForm = [];

      if (
        state.ESIdetails.ESIDATAS.nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.nominee_relationship != "null" &&
        state.ESIdetails.ESIDATAS.nominee_relationship.toUpperCase()
      ) {
        setnomieeFirst({
          value: state.ESIdetails.ESIDATAS.nominee_relationship,
          label: state.ESIdetails.ESIDATAS.nominee_relationship.toUpperCase(),
        });
      }

      if (
        state.ESIdetails.ESIDATAS.second_nominee_dob != null &&
        state.ESIdetails.ESIDATAS.second_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.second_nominee_relationship != "null" &&
        state.ESIdetails.ESIDATAS.second_nominee_relationship.toUpperCase()
      ) {
        setnomieesecond({
          value: state.ESIdetails.ESIDATAS.second_nominee_relationship,
          label:
            state.ESIdetails.ESIDATAS.second_nominee_relationship.toUpperCase(),
        });
      }

      if (
        state.ESIdetails.ESIDATAS.third_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.third_nominee_relationship != "null" &&
        state.ESIdetails.ESIDATAS.third_nominee_relationship.toUpperCase()
      ) {
        setThirdNomieeOptFam({
          value: state.ESIdetails.ESIDATAS.third_nominee_relationship,
          label:
            state.ESIdetails.ESIDATAS.third_nominee_relationship.toUpperCase(),
        });
      }

      if (
        state.ESIdetails.ESIDATAS.fourth_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.fourth_nominee_relationship != "null" &&
        state.ESIdetails.ESIDATAS.fourth_nominee_relationship.toUpperCase()
      ) {
        setFourthenomieeFam({
          value: state.ESIdetails.ESIDATAS.fourth_nominee_relationship,
          label:
            state.ESIdetails.ESIDATAS.fourth_nominee_relationship.toUpperCase(),
        });
      }

      OptionsFam.forEach((element) => {
        if (
          state.ESIdetails.ESIDATAS.nominee_relationship != null &&
          state.ESIdetails.ESIDATAS.nominee_relationship != "null" &&
          state.ESIdetails.ESIDATAS.nominee_relationship.toUpperCase() ==
            element.label.toUpperCase()
        ) {
          updatedRelations.push({
            value: state.ESIdetails.ESIDATAS.nominee_relationship,
            label: state.ESIdetails.ESIDATAS.nominee_relationship,
          });
        }
        if (
          state.ESIdetails.ESIDATAS.second_nominee_relationship != null &&
          state.ESIdetails.ESIDATAS.second_nominee_relationship != "null" &&
          state.ESIdetails.ESIDATAS.second_nominee_relationship.toUpperCase() ==
            element.label
        ) {
          updatedRelations.push({
            value: state.ESIdetails.ESIDATAS.second_nominee_relationship,
            label: state.ESIdetails.ESIDATAS.second_nominee_relationship,
          });
        }
      });
      const dynamicValue =
        state.ESIdetails.ESIDATAS.nominee_relationship != "" &&
        state.ESIdetails.ESIDATAS.nominee_relationship != undefined &&
        state.ESIdetails.ESIDATAS.nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.nominee_relationship != "null"
          ? state.ESIdetails.ESIDATAS.nominee_relationship
          : "";
      const DynamicSecondval =
        state.ESIdetails.ESIDATAS.second_nominee_relationship != "" &&
        state.ESIdetails.ESIDATAS.second_nominee_relationship != undefined &&
        state.ESIdetails.ESIDATAS.second_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.second_nominee_relationship != "null"
          ? state.ESIdetails.ESIDATAS.second_nominee_relationship
          : "";
      const remainingOptions = FamilyOptions.filter((option) => {
        const optionLabel = option.label.toUpperCase();
        return (
          optionLabel !== DynamicSecondval &&
          optionLabel !== dynamicValue.toUpperCase()
        );
      });
      setNameOfRelations(updatedRelations);
      if (
        state.ESIdetails.ESIDATAS.second_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.third_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.third_nominee_relationship != "null" &&
        state.ESIdetails.ESIDATAS.fourth_nominee_relationship != null
      ) {
        setNumberOfFileds(4);
        setInputFields({
          ...inputFields,
          InputFieldsNum: [2, 3, 4],
        });
      }
      if (
        state.ESIdetails.ESIDATAS.second_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.third_nominee_relationship === null &&
        state.ESIdetails.ESIDATAS.fourth_nominee_relationship == null
      ) {
        setNumberOfFileds(2);
        setInputFields({
          ...inputFields,
          InputFieldsNum: [2],
        });
      }

      if (
        state.ESIdetails.ESIDATAS.second_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.third_nominee_relationship != null &&
        state.ESIdetails.ESIDATAS.third_nominee_relationship != "null" &&
        state.ESIdetails.ESIDATAS.fourth_nominee_relationship == null
      ) {
        setNumberOfFileds(3);
        setInputFields({
          ...inputFields,
          InputFieldsNum: [2, 3],
        });
      }
    }
  }, [
    state.ESIdetails.ESIDATAS,
    state.FormsIDList.ActiveTabs,
    state.ESIdetails.ESIDATAS.father_husband_name,
  ]);

  useEffect(() => {
    let newImages = [...images];

    if (
      state.FormsIDList.ESIFormsid != " " &&
      state.ESIdetails.ESIDATAS.id != undefined &&
      state.FormsIDList.ESIFormsid == state.ESIdetails.ESIDATAS.id
    ) {
      if (
        state.ESIdetails.ESIDATAS.nominee_image != undefined &&
        state.ESIdetails.ESIDATAS.nominee_image != null &&
        state.ESIdetails.ESIDATAS.nominee_image &&
        state.ESIdetails.ESIDATAS.nominee_image != "null"
      ) {
        newImages[0] = state.ESIdetails.ESIDATAS.nominee_image; // 10th image as 1st index
      }
      if (
        state.ESIdetails.ESIDATAS.second_nominee_image != null &&
        state.ESIdetails.ESIDATAS.second_nominee_image != undefined &&
        state.ESIdetails.ESIDATAS.second_nominee_image &&
        state.ESIdetails.ESIDATAS.second_nominee_image != "null"
      ) {
        newImages[1] = state.ESIdetails.ESIDATAS.second_nominee_image; // 12th image as 2nd index
      }
      if (
        state.ESIdetails.ESIDATAS.third_nominee_image != undefined &&
        state.ESIdetails.ESIDATAS.third_nominee_image != null &&
        state.ESIdetails.ESIDATAS.third_nominee_image &&
        state.ESIdetails.ESIDATAS.third_nominee_image &&
        state.ESIdetails.ESIDATAS.third_nominee_image != "null"
      ) {
        newImages[2] = state.ESIdetails.ESIDATAS.third_nominee_image; // Diploma image as 3rd index
      }
      if (
        state.ESIdetails.ESIDATAS.fourth_nominee_image != null &&
        state.ESIdetails.ESIDATAS.fourth_nominee_image != undefined &&
        state.ESIdetails.ESIDATAS.fourth_nominee_image &&
        state.ESIdetails.ESIDATAS.fourth_nominee_image &&
        state.ESIdetails.ESIDATAS.fourth_nominee_image != "null"
      ) {
        newImages[3] = state.ESIdetails.ESIDATAS.fourth_nominee_image; // UG image as 4th index
      }
    }

    setImages(newImages);
    setPresentImages(newImages);
  }, [state.FormsIDList.ESIFormsid, state.ESIdetails.ESIDATAS]);

  useEffect(() => {
    ////---data---fetch
    if (
      state.FormsIDList.BasicFormID != "" &&
      state.FormsIDList.ActiveTabs == 9 &&
      state.NumberCounts.Editable != 1
    ) {
      const payload = {
        user_id: state.BasicFormCreated.user_ID,
      };
      dispatch(settheDataFetchActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);

  ///----Data---fetch--------------------
  useEffect(() => {
    if (
      state.FormsIDList.ESIFormsid == "" &&
      state.FormsIDList.BasicFormID != "" &&
      state.DatafetchCall.DataFetchDatass != undefined &&
      state.FormsIDList.ActiveTabs == 9
    ) {
      setData({
        ...data,
        employee_name: state.DatafetchCall.DataFetchDatass.first_name,
        address_temporary: state.DatafetchCall.DataFetchDatass.present_address,
        address_permanent:
          state.DatafetchCall.DataFetchDatass.permanent_address,

        email: state.DatafetchCall.DataFetchDatass.email_id,
        gender: state.DatafetchCall.DataFetchDatass.gender,
        account_number: state.DatafetchCall.DataFetchDatass.account_number,
        date_of_birth: state.DatafetchCall.DataFetchDatass.date_of_birth,
      });
    }
  }, [state.DatafetchCall.DataFetchDatass]);

  useEffect(() => {
    if (
      state.FormsIDList.ESIFormsid != "" &&
      state.ESIdetails.ESIDATAS.id != undefined &&
      state.FormsIDList.ESIFormsid == state.ESIdetails.ESIDATAS.id &&
      state.NumberCounts.Editable == 1
    ) {
      console.log(state.ESIdetails.ESIDATAS.gender.toLowerCase(), "gender");
      if (state.ESIdetails.ESIDATAS.gender.toLowerCase() == "male") {
        SetGender({
          ...ForGender,
          Male: true,
        });
      } else if (state.ESIdetails.ESIDATAS.gender.toLowerCase() == "female") {
        SetGender({
          ...ForGender,
          Female: true,
        });
      } else if (state.ESIdetails.ESIDATAS.gender.toLowerCase() == "others") {
        SetGender({
          ...ForGender,
          other: true,
        });
      }
    }
  }, [state.ESIdetails.ESIDATAS]);
  ////---PassBook-------or -------------cheque----changes---
  const handleCheckChnages = (e, name, value, values) => {
    setPassChe({
      ...PasChec,
      Father: value,
      husband: values,
    });
    if (value == false) {
      setData({
        ...data,
        NameOfFamliy: name,
        FatherName: "",
      });
    } else if (value) {
      setData({
        ...data,
        NameOfFamliy: name,
        FatherORHUSBANDNAME: "",
      });
    }
  };

  const inputRef = useRef(null);
  const preventZoom = (event) => {
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "+" || event.key === "-" || event.type === "wheel")
    ) {
      event.preventDefault();
    }
    if (
      ["e", "E", "+", "-", "."].includes(event.key) ||
      event.key === "ArrowUp" ||
      event.key === "ArrowDown"
    ) {
      event.preventDefault();
    }
  };
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");
    const filtered = paste.replace(/[^0-9]/g, "");
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      inputElement.addEventListener("wheel", preventZoom);
    }

    // Cleanup to remove the event listener when the component unmounts
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", preventZoom);
      }
    };
  }, []);

  ///---Next----
  const HandleNext = () => {
    var a = 0;
    const fetchUploadFiles = async () => {
      await Promise.all(
        PresentUrls.map(async (item, index) => {
          try {
            if (item != undefined && item != null) {
              const response = await fetch(item.url, {
                method: "PUT",
                headers: {
                  "Content-Type": item.type,
                  "x-amz-acl": "public-read",
                },
                body: item.putfiles,
              });
              if (PresentUrls.length == index + 1) {
                setImageFileChange([false, false, false, false, false, false]);
              }
            }
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        }),
      );
    };

    if (state.FormsIDList.ESIFormsid != "") {
      var AnyoneName = PasChec.Father
        ? data.FatherName
        : data.FatherORHUSBANDNAME;

      var concatenatedfatherorhusband =
        AnyoneName + "@@@@####@@@@" + data.NameOfFamliy;

      var concatenated =
        data.NameOfNomiees + "@@@@####@@@@ " + data.AddressOf_nomoiees;
      var concatenatedProcessed = concatenated
        ? concatenated.replace(/\s+/g, " ").trim()
        : "";

      var nomineeNameAddressProcessed = state?.ESIdetails?.ESIDATAS
        ?.nominee_name_address
        ? state.ESIdetails.ESIDATAS.nominee_name_address
            .replace(/\s+/g, " ")
            .trim()
        : "";
      var concatenatedSecondNomiee =
        data.secondNomiees + "@@@@####@@@@" + data.AddressOf_second_nomoiee;

      var concatenatedSecondProcessed = concatenatedSecondNomiee
        ? concatenatedSecondNomiee.replace(/\s+/g, " ").trim()
        : "";
      var nomineeNameAddressPsecondrocessed = state?.ESIdetails?.ESIDATAS
        ?.second_nominee_name_address
        ? state.ESIdetails.ESIDATAS.second_nominee_name_address
            .replace(/\s+/g, " ")
            .trim()
        : "";

      var concatenatedThird =
        data.NameofthidNomirr + "@@@@####@@@@" + data.addressofthirdnomiee;
      var concatenatedFourth =
        data.NameoffourthNomirr + "@@@@####@@@@" + data.addressoffourthnomiee;

      var concatenatedthirdonerocessed = concatenatedThird
        ? concatenatedThird.replace(/\s+/g, " ").trim()
        : "";

      var concatenatedFourthonerocessed = concatenatedFourth
        ? concatenatedFourth.replace(/\s+/g, " ").trim()
        : "";

      var NomieesThirdNameAndAddress = state?.ESIdetails?.ESIDATAS
        ?.third_nominee_name_address
        ? state.ESIdetails.ESIDATAS.third_nominee_name_address
            .replace(/\s+/g, " ")
            .trim()
        : "";

      var NomieesFourthNameAndAddress = state?.ESIdetails?.ESIDATAS
        ?.fourth_nominee_name_address
        ? state.ESIdetails.ESIDATAS.fourth_nominee_name_address
            .replace(/\s+/g, " ")
            .trim()
        : "";
    }

    if (
      a == 0 &&
      ErroIndex == 0 &&
      (imageFileChange[0] === true ||
        imageFileChange[1] === true ||
        imageFileChange[2] === true ||
        imageFileChange[3] === true ||
        imageFileChange[4] === true ||
        imageFileChange[5] === true)
    ) {
      fetchUploadFiles();
    }

    if (state.FormsIDList.ESIFormsid == "") {
      if (data.employee_name == "") {
        a = 1;
        setEmpNaErr("*Name is required");
      }
      if (data.marital_status == "") {
        a = 1;
        setMatriErr("*Marital status is required");
      }

      if (
        data.previous_ESI_number != null &&
        data.previous_ESI_number != "" &&
        data.previous_ESI_number.length < 10
      ) {
        setpreviousESi("*ESI number should not less than 10 digits");
        a = 1;
      }
      if (PasChec.Father) {
        if (data.FatherName == "") {
          a = 1;
          setFatherErr("*Father  name is required");
        }
      }

      if (PasChec.husband) {
        if (data.FatherORHUSBANDNAME == "") {
          setFaErr("*Husband name is required");
          a = 1;
        }
      }
      if (data.gender == "") {
        a = 1;
        setGenderErr("*Gender  Name is required");
      }

      if (data.date_of_joining == "") {
        a = 1;
        setDateErr("*Date of joining  is required");
      }
      if (data.date_of_birth == "") {
        a = 1;
        setDateBErr("*Date Of Birth  is required");
      }

      // if (data.esi_dispensary == "") {
      //   a = 1;
      //   setEpsErr("*ESI Dispensary is required");
      // }

      if (data.NameOfNomiees == "") {
        setnoimeeErr("*Nominee name is  required");
        a = 1;
      }

      if (data.AddressOf_nomoiees == "") {
        a = 1;
        setNoimerr("*Nominee Address is required");
      }

      if (data.nominee_dob == "") {
        a = 1;
        setnoimeeDobErr("*Nominee DOB  is required");
      }

      if (data.nominee_relationship == "") {
        a = 1;
        setnoimeerr("*Nominee Relationship  is required");
      }

      if (data.if_nominee_minor == "") {
        a = 1;
        setIfnoimeeErr("*Please enter the details");
      }

      if (data.percentage == "") {
        a = 1;
        setTotalErr("*Share amount is required");
      }

      // if (Presentimages[0] ==  null ||Presentimages[0] == undefined || Presentimages[0] == '') {

      //   setNomieeImageError("*Nominee image is required")
      //   a = 1;
      // }

      if (inputFields.InputFieldsNum.includes(2)) {
        if (data.secondNomiees == "") {
          setsecondNomieesError("*Second Nominee name  is  required");
          a = 1;
        }

        if (data.AddressOf_second_nomoiee == "") {
          a = 1;
          SetAddressOf_second_nomoieeError(
            "*Second Nominee Address is required",
          );
        }

        if (data.second_nominee_dob == "" || data.second_nominee_dob == null) {
          a = 1;
          setsecond_nominee_dobError("*Second Nominee DOB  is required");
        }

        if (
          data.second_nominee_relationship == "" ||
          data.second_nominee_relationship == null
        ) {
          a = 1;
          setRelationError("*Second Nominee Relationship  is required");
        }

        if (
          data.second_if_nominee_minor == "" ||
          data.second_if_nominee_minor == null
        ) {
          a = 1;
          setIfsecondErro("*Please enter the details");
        }

        // if (data.second_total_amount != 0 && data.second_total_amount != "") {
        if (
          (data.second_total_amount === "" && data.second_total_amount !== 0) ||
          data.second_total_amount == null
        ) {
          a = 1;
          setSecondNomieTotal("*Share amount is required");
        }
        //   if (Presentimages[1] ==  null ||Presentimages[1] == undefined || Presentimages[1] == '') {

        //   setNomieeSecondImageError("*Second nominee image is required")
        //   a = 1;
        // }
      }

      //  }
      if (inputFields.InputFieldsNum.includes(3)) {
        if (data.NameofthidNomirr === "" || data.NameofthidNomirr === null) {
          setThirdNomineesError("*Third Nominee name is required");
          a = 1;
        }

        if (
          data.addressofthirdnomiee === "" ||
          data.addressofthirdnomiee === null
        ) {
          setAddressOf_third_nomineeError("*Third Nominee Address is required");
          a = 1;
        }

        if (data.third_nominee_dob === "" || data.third_nominee_dob === null) {
          setThird_nominee_dobError("*Third Nominee DOB is required");
          a = 1;
        }

        if (
          data.third_nominee_relationship === "" ||
          data.third_nominee_relationship === null
        ) {
          setThirdRelationError("*Third Nominee Relationship is required");
          a = 1;
        }

        if (
          data.third_if_nominee_minor === "" ||
          data.third_if_nominee_minor === null
        ) {
          setIfThirdError("*Please enter the details");
          a = 1;
        }

        if (
          (data.third_total_amount === "" && data.third_total_amount !== 0) ||
          data.third_total_amount == null
        ) {
          a = 1;
          setIfThirdTotalError("*Share amount is required");
        }
        // if (Presentimages[2] ==  null ||Presentimages[2] == undefined || Presentimages[2] == "") {

        //   setNomieeThirdImageError("*Third nominee image is required")
        //   a = 1;
        // }
      }

      if (inputFields.InputFieldsNum.includes(4)) {
        if (
          data.NameoffourthNomirr === "" ||
          data.NameoffourthNomirr === null
        ) {
          setFourthNomineesError("*Fourth Nominee name is required");
          a = 1;
        }

        if (
          data.addressoffourthnomiee === "" ||
          data.addressoffourthnomiee === null
        ) {
          setAddressOf_fourth_nomineeError(
            "*Fourth Nominee Address is required",
          );
          a = 1;
        }

        if (
          data.fourth_nominee_dob === "" ||
          data.fourth_nominee_dob === null
        ) {
          setFourth_nominee_dobError("*Fourth Nominee DOB is required");
          a = 1;
        }

        if (
          data.fourth_nominee_relationship === "" ||
          data.fourth_nominee_relationship === null
        ) {
          setFourthRelationError("*Fourth Nominee Relationship is required");
          a = 1;
        }

        if (
          data.fourth_if_nominee_minor === "" ||
          data.fourth_if_nominee_minor === null
        ) {
          setIfFourthError("*Please enter the details");
          a = 1;
        }
        if (
          (data.fourth_total_amount === "" && data.fourth_total_amount !== 0) ||
          data.fourth_total_amount == null
        ) {
          a = 1;
          setFourthTotalError("*Share amount is required");
        }
        // if (Presentimages[3] ==  null ||Presentimages[3] == undefined || Presentimages[3] == "") {

        //   setNomieeFourImageError("*Fourth nominee image is required")
        //   a = 1;
        // }
      }

      if (a == 0 && ErroIndex == 0) {
        const concatenated =
          data.NameOfNomiees + "@@@@####@@@@ " + data.AddressOf_nomoiees;

        const concatenatedThird =
          data.NameofthidNomirr + "@@@@####@@@@ " + data.addressofthirdnomiee;
        const concatenatedFourth =
          data.NameoffourthNomirr +
          "@@@@####@@@@ " +
          data.addressoffourthnomiee;

        const concatenatedSecondNomiee =
          data.secondNomiees + "@@@@####@@@@ " + data.AddressOf_second_nomoiee;
        const AnyoneName = PasChec.Father
          ? data.FatherName
          : data.FatherORHUSBANDNAME;

        const concatenatedfatherorhusband =
          AnyoneName + "@@@@####@@@@" + data.NameOfFamliy;

        let dataSend = {
          employee_name: data.employee_name,
          marital_status: data.marital_status,
          father_husband_name: concatenatedfatherorhusband,
          gender: data.gender,
          date_of_joining:
            data.date_of_joining == "" ? null : data.date_of_joining,
          e_p_f: data.e_p_f,
          e_p_s: data.e_p_s,
          date_of_birth: data.date_of_birth,
          address_temporary: data.address_temporary,
          address_permanent: data.address_permanent,
          account_number: data.account_number,
          // total_amount:
          //   data.percentage != 100
          //     ? Number(data.second_total_amount) + Number(data.percentage)
          //     : 100,
          total_amount: data.total_amount,

          nominee_relationship: data.nominee_relationship,
          nominee_name_address: concatenated,
          nominee_dob: data.nominee_dob == "" ? null : data.nominee_dob,
          if_nominee_minor: data.if_nominee_minor,
          percentage: data.percentage, ///---second Nomiees
          second_nominee_name_address:
            concatenatedSecondNomiee == "" ? null : concatenatedSecondNomiee,
          second_nominee_relationship:
            data.second_nominee_relationship == ""
              ? null
              : data.second_nominee_relationship,
          second_if_nominee_minor:
            data.second_if_nominee_minor == ""
              ? null
              : data.second_if_nominee_minor,
          second_nominee_dob:
            data.second_nominee_dob == "" ? null : data.second_nominee_dob,
          second_percentage: data.second_percentage,
          second_total_amount: data.second_total_amount,
          // timeline_id: state.BasicFormCreated.BasciFormCreate,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          esi_dispensary: data.esi_dispensary,
          previous_ESI_number: data.previous_ESI_number,

          third_if_nominee_minor: data.third_if_nominee_minor,
          third_nominee_dob: data.third_nominee_dob,
          third_nominee_name_address: concatenatedThird,
          third_nominee_relationship: data.third_nominee_relationship,
          third_percentage: data.third_percentage,
          third_total_amount: data.third_total_amount,
          //--four
          fourth_if_nominee_minor: data.fourth_if_nominee_minor,
          fourth_nominee_dob: data.fourth_nominee_dob,
          fourth_nominee_name_address: concatenatedFourth,
          fourth_nominee_relationship: data.fourth_nominee_relationship,
          fourth_percentage: data.fourth_percentage,
          fourth_total_amount: data.fourth_total_amount,
          nominee_image: Presentimages[0],
          second_nominee_image: Presentimages[1],
          third_nominee_image: Presentimages[2],
          fourth_nominee_image: Presentimages[3],
        };
        const payload = {
          data: dataSend,
          Funcations: () => {
            // Your function logic here
            console.log("Function called");
            Navigate("/employeeprofile");
          },
        };
        dispatch(SetESICraeteCALLAction(payload));
        setcount(2);
      }
    }

    if (
      state.FormsIDList.ESIFormsid != "" &&
      state.ESIdetails.ESIDATAS != undefined
    ) {
      if (data.employee_name == "") {
        a = 1;
        setEmpNaErr("*Name is required");
      }
      if (data.marital_status == "") {
        a = 1;
        setMatriErr("*Marital status is required");
      }

      // if (data.father_husband_name == "") {
      if (PasChec.Father) {
        if (data.FatherName == "") {
          a = 1;
          setFatherErr("*Father  name is required");
        }
      }

      if (PasChec.husband) {
        if (data.FatherORHUSBANDNAME == "") {
          setFaErr("*Husband name is required");
          a = 1;
        }
      }
      if (data.gender == "") {
        a = 1;
        setGenderErr("*Gender  Name is required");
      }

      if (data.date_of_joining == "") {
        a = 1;
        setDateErr("*Date of joining  is required");
      }
      if (data.date_of_birth == "") {
        a = 1;
        setDateBErr("*Date Of Birth  is required");
      }
      // if (data.account_number == "") {
      //   a = 1;
      //   setAccountErr("*Account Number is required");
      // }
      // if (data.address_permanent == "") {
      //   a = 1;
      //   setAddressPerErr("*Permanent Address  is required");
      // }
      // if (data.address_temporary == "") {
      //   a = 1;
      //   setAddretemErr("*Temporary Address  is required");
      // }

      // if (data.e_p_f == "") {
      //   a = 1;
      //   setEpFErr("*E P F   is required");
      // }

      // if (data.esi_dispensary == "" || data.esi_dispensary == null) {
      //   a = 1;
      //   setEpsErr("*ESI Dispensary is required");
      // }

      if (data.NameOfNomiees == "") {
        setnoimeeErr("*Nominee name  is  required");
        a = 1;
      }

      if (data.AddressOf_nomoiees == "") {
        a = 1;
        setNoimerr("*Nominee Address   is required");
      }

      if (data.nominee_dob == "") {
        a = 1;
        setnoimeeDobErr("*Nominee DOB  is required");
      }

      if (data.nominee_relationship == "") {
        a = 1;
        setnoimeerr("*Nominee Relationship  is required");
      }

      if (data.if_nominee_minor == "") {
        a = 1;
        setIfnoimeeErr("*Please enter the details");
      }

      // if (Presentimages[0] ==  null ||Presentimages[0] == undefined || Presentimages[0] == '') {

      //   setNomieeImageError("*Nominee image is required")
      //   a = 1;
      // }

      if (inputFields.InputFieldsNum.includes(2)) {
        if (data.secondNomiees == "") {
          setsecondNomieesError("*Second Nominee name  is  required");
          a = 1;
        }

        if (data.AddressOf_second_nomoiee == "") {
          a = 1;
          SetAddressOf_second_nomoieeError(
            "*Second Nominee Address is required",
          );
        }

        if (data.second_nominee_dob == "" || data.second_nominee_dob == null) {
          a = 1;
          setsecond_nominee_dobError("*Second Nominee DOB  is required");
        }

        if (
          data.second_nominee_relationship == "" ||
          data.second_nominee_relationship == null
        ) {
          a = 1;
          setRelationError("*Second Nominee Relationship  is required");
        }

        if (
          data.second_if_nominee_minor == "" ||
          data.second_if_nominee_minor == null
        ) {
          a = 1;
          setIfsecondErro("*Please enter the details");
        }

        // if (data.second_total_amount != 0 && data.second_total_amount != "") {
        if (
          (data.second_total_amount === "" && data.second_total_amount !== 0) ||
          data.second_total_amount == null
        ) {
          a = 1;
          setSecondNomieTotal("*Share amount is required");
        }

        // if (Presentimages[1] ==  null ||Presentimages[1] == undefined || Presentimages[1] == '') {

        //   setNomieeSecondImageError("*Second nominee image is required")
        //   a = 1;
        // }
      }

      //  }
      if (inputFields.InputFieldsNum.includes(3)) {
        if (data.NameofthidNomirr === "" || data.NameofthidNomirr === null) {
          setThirdNomineesError("*Third Nominee name is required");
          a = 1;
        }

        if (
          data.addressofthirdnomiee === "" ||
          data.addressofthirdnomiee === null
        ) {
          setAddressOf_third_nomineeError("*Third Nominee Address is required");
          a = 1;
        }

        if (data.third_nominee_dob === "" || data.third_nominee_dob === null) {
          setThird_nominee_dobError("*Third Nominee DOB is required");
          a = 1;
        }

        if (
          data.third_nominee_relationship === "" ||
          data.third_nominee_relationship === null
        ) {
          setThirdRelationError("*Third Nominee Relationship is required");
          a = 1;
        }

        if (
          data.third_if_nominee_minor === "" ||
          data.third_if_nominee_minor === null
        ) {
          setIfThirdError("*Please enter the details");
          a = 1;
        }

        if (
          (data.third_total_amount === "" && data.third_total_amount !== 0) ||
          data.third_total_amount == null
        ) {
          a = 1;
          setIfThirdTotalError("*Share amount is required");
        }
        // if (Presentimages[2] ==  null ||Presentimages[2] == undefined || Presentimages[2] == "") {

        //   setNomieeThirdImageError("*Third nominee image is required")
        //   a = 1;
        // }
      }

      if (inputFields.InputFieldsNum.includes(4)) {
        if (
          data.NameoffourthNomirr === "" ||
          data.NameoffourthNomirr === null
        ) {
          setFourthNomineesError("*Fourth Nominee name is required");
          a = 1;
        }

        if (
          data.addressoffourthnomiee === "" ||
          data.addressoffourthnomiee === null
        ) {
          setAddressOf_fourth_nomineeError(
            "*Fourth Nominee Address is required",
          );
          a = 1;
        }

        if (
          data.fourth_nominee_dob === "" ||
          data.fourth_nominee_dob === null
        ) {
          setFourth_nominee_dobError("*Fourth Nominee DOB is required");
          a = 1;
        }

        if (
          data.fourth_nominee_relationship === "" ||
          data.fourth_nominee_relationship === null
        ) {
          setFourthRelationError("*Fourth Nominee Relationship is required");
          a = 1;
        }

        if (
          data.fourth_if_nominee_minor === "" ||
          data.fourth_if_nominee_minor === null
        ) {
          setIfFourthError("*Please enter the details");
          a = 1;
        }
        if (
          (data.fourth_total_amount === "" && data.fourth_total_amount !== 0) ||
          data.fourth_total_amount == null
        ) {
          a = 1;
          setFourthTotalError("*Share amount is required");
        }
        // if (Presentimages[3] ==  null ||Presentimages[3] == undefined || Presentimages[3] == "") {

        //   setNomieeFourImageError("*Fourth nominee image is required")
        //   a = 1;
        // }
      }

      if (
        data.previous_ESI_number != null &&
        data.previous_ESI_number != "" &&
        data.previous_ESI_number.length < 10
      ) {
        setpreviousESi("*ESI number should not less than 10 digits");
        a = 1;
      }
      // if (data.total_amount == "") {
      //   a = 1;
      //   setTotalErr("*share amount is required");
      // }
      if (data.percentage == "") {
        a = 1;
        setTotalErr("*Share amount is required");
      }
    }

    if (
      (state.FormsIDList.ESIFormsid != "" &&
        a != 1 &&
        // a == 0 &&
        state.FormsIDList.ESIFormsid == state.ESIdetails.ESIDATAS.id &&
        state.FormsIDList.ESIFormsid != undefined &&
        state.FormsIDList.ESIFormsid != null &&
        state.FormsIDList.ESIFormsid != "" &&
        state.FormsIDList.ESIFormsid != "" &&
        data.employee_name != state.ESIdetails.ESIDATAS.employee_name) ||
      data.marital_status != state.ESIdetails.ESIDATAS.marital_status ||
      concatenatedfatherorhusband !=
        state.ESIdetails.ESIDATAS.father_husband_name ||
      data.date_of_joining != state.ESIdetails.ESIDATAS.date_of_joining ||
      data.gender != state.ESIdetails.ESIDATAS.gender ||
      data.date_of_birth != state.ESIdetails.ESIDATAS.date_of_birth ||
      data.e_p_f != state.ESIdetails.ESIDATAS.e_p_f ||
      data.e_p_s != state.ESIdetails.ESIDATAS.e_p_s ||
      data.address_temporary != state.ESIdetails.ESIDATAS.address_temporary ||
      data.address_permanent != state.ESIdetails.ESIDATAS.address_permanent ||
      data.account_number != state.ESIdetails.ESIDATAS.account_number ||
      // // data.total_amount != state.ESIdetails.ESIDATAS.total_amount ||
      data.nominee_relationship !=
        state.ESIdetails.ESIDATAS.nominee_relationship ||
      concatenatedProcessed !== nomineeNameAddressProcessed || // data.nominee_dob != state.ESIdetails.ESIDATAS.nominee_dob ||
      data.if_nominee_minor != state.ESIdetails.ESIDATAS.if_nominee_minor ||
      data.percentage != state.ESIdetails.ESIDATAS.percentage ||
      data.esi_dispensary != state.ESIdetails.ESIDATAS.esi_dispensary ||
      data.second_percentage != state.ESIdetails.ESIDATAS.second_percentage ||
      data.second_if_nominee_minor !=
        state.ESIdetails.ESIDATAS.second_if_nominee_minor ||
      data.second_nominee_relationship !=
        state.ESIdetails.ESIDATAS.second_nominee_relationship ||
      data.second_nominee_dob != state.ESIdetails.ESIDATAS.second_nominee_dob ||
      concatenatedSecondProcessed != nomineeNameAddressPsecondrocessed ||
      data.previous_ESI_number !=
        state.ESIdetails.ESIDATAS.previous_ESI_number ||
      data.third_if_nominee_minor !=
        state.ESIdetails.ESIDATAS.third_if_nominee_minor ||
      data.third_nominee_dob != state.ESIdetails.ESIDATAS.third_nominee_dob ||
      concatenatedthirdonerocessed != NomieesThirdNameAndAddress ||
      data.third_nominee_relationship !=
        state.ESIdetails.ESIDATAS.third_nominee_relationship ||
      data.third_percentage != state.ESIdetails.ESIDATAS.third_percentage ||
      data.third_total_amount != state.ESIdetails.ESIDATAS.third_total_amount ||
      data.fourth_if_nominee_minor !=
        state.ESIdetails.ESIDATAS.fourth_if_nominee_minor ||
      data.fourth_nominee_dob != state.ESIdetails.ESIDATAS.fourth_nominee_dob ||
      concatenatedFourthonerocessed != NomieesFourthNameAndAddress ||
      data.fourth_nominee_relationship !=
        state.ESIdetails.ESIDATAS.fourth_nominee_relationship ||
      data.fourth_percentage != state.ESIdetails.ESIDATAS.fourth_percentage ||
      data.fourth_total_amount !=
        state.ESIdetails.ESIDATAS.fourth_total_amount ||
      data.nominee_image != Presentimages[0] ||
      data.second_nominee_image != Presentimages[1] ||
      data.third_nominee_image != Presentimages[2] ||
      data.fourth_nominee_image != Presentimages[3]
    ) {
      if (a == 0 && ErroIndex == 0) {
        const concatenatedSecondNomiee =
          data.secondNomiees + "@@@@####@@@@" + data.AddressOf_second_nomoiee;
        const concatenated =
          data.NameOfNomiees + "@@@@####@@@@" + data.AddressOf_nomoiees;

        let dataSend = {
          employee_name: data.employee_name,
          marital_status: data.marital_status,
          // father_husband_name: data.father_husband_name,
          father_husband_name: concatenatedfatherorhusband,
          gender: data.gender,
          date_of_joining:
            data.date_of_joining == "" ? null : data.date_of_joining,
          e_p_f: data.e_p_f,
          e_p_s: data.e_p_s,
          date_of_birth: data.date_of_birth,
          address_temporary: data.address_temporary,
          address_permanent: data.address_permanent,
          account_number: data.account_number,
          // total_amount: data.total_amount,
          // total_amount:
          //   data.percentage != 100
          //     ? Number(data.second_total_amount) + Number(data.percentage)
          //     : 100,

          total_amount: data.total_amount,
          nominee_relationship: data.nominee_relationship,
          nominee_name_address: concatenated,
          nominee_dob: data.nominee_dob == "" ? null : data.nominee_dob,
          if_nominee_minor: data.if_nominee_minor,
          percentage: data.percentage, ///---second Nomiees
          previous_ESI_number: data.previous_ESI_number,
          ///---second Nomiees

          second_nominee_name_address:
            concatenatedSecondNomiee == "" ? null : concatenatedSecondNomiee,
          second_nominee_relationship:
            data.second_nominee_relationship == ""
              ? null
              : data.second_nominee_relationship,
          second_if_nominee_minor:
            data.second_if_nominee_minor == ""
              ? null
              : data.second_if_nominee_minor,
          second_nominee_dob:
            data.second_nominee_dob == "" ? null : data.second_nominee_dob,
          second_total_amount: data.second_total_amount,
          second_percentage: data.second_percentage,
          // timeline_id: state.BasicFormCreated.BasciFormCreate,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          esi_dispensary: data.esi_dispensary,
          third_if_nominee_minor: data.third_if_nominee_minor,
          third_nominee_dob: data.third_nominee_dob,
          third_nominee_name_address: concatenatedThird,
          third_nominee_relationship: data.third_nominee_relationship,
          third_percentage: data.third_percentage,
          third_total_amount: data.third_total_amount,

          //--four
          fourth_if_nominee_minor: data.fourth_if_nominee_minor,
          fourth_nominee_dob: data.fourth_nominee_dob,
          fourth_nominee_name_address: concatenatedFourth,
          fourth_nominee_relationship: data.fourth_nominee_relationship,
          fourth_percentage: data.fourth_percentage,
          fourth_total_amount: data.fourth_total_amount,
          nominee_image: Presentimages[0],
          second_nominee_image: Presentimages[1],
          third_nominee_image: Presentimages[2],
          fourth_nominee_image: Presentimages[3],
        };
        const payload = {
          data: dataSend,
          Retieveid: state.FormsIDList.ESIFormsid,
          Pushtoprofile: state.NumberCounts.Editable,
          Funcations: () => {
            Navigate("/employeeprofile");
          },
        };

        dispatch(SetESIEditCALLAction(payload));
        setcount(2);
      }
    }

    if (
      a != 1 &&
      state.FormsIDList.ESIFormsid == state.ESIdetails.ESIDATAS.id &&
      state.FormsIDList.ESIFormsid != "" &&
      data.employee_name == state.ESIdetails.ESIDATAS.employee_name &&
      data.marital_status == state.ESIdetails.ESIDATAS.marital_status &&
      concatenatedfatherorhusband ==
        state.ESIdetails.ESIDATAS.father_husband_name &&
      data.date_of_joining == state.ESIdetails.ESIDATAS.date_of_joining &&
      data.gender == state.ESIdetails.ESIDATAS.gender &&
      data.date_of_birth == state.ESIdetails.ESIDATAS.date_of_birth &&
      data.e_p_f == state.ESIdetails.ESIDATAS.e_p_f &&
      data.e_p_s == state.ESIdetails.ESIDATAS.e_p_s &&
      data.address_temporary == state.ESIdetails.ESIDATAS.address_temporary &&
      data.address_permanent == state.ESIdetails.ESIDATAS.address_permanent &&
      data.account_number == state.ESIdetails.ESIDATAS.account_number &&
      // // data.total_amount != state.ESIdetails.ESIDATAS.total_amount ||
      data.nominee_relationship ==
        state.ESIdetails.ESIDATAS.nominee_relationship &&
      concatenatedProcessed == nomineeNameAddressProcessed && // data.nominee_dob != state.ESIdetails.ESIDATAS.nominee_dob ||
      data.if_nominee_minor == state.ESIdetails.ESIDATAS.if_nominee_minor &&
      data.percentage == state.ESIdetails.ESIDATAS.percentage &&
      data.esi_dispensary == state.ESIdetails.ESIDATAS.esi_dispensary &&
      data.second_percentage == state.ESIdetails.ESIDATAS.second_percentage &&
      data.second_if_nominee_minor ==
        state.ESIdetails.ESIDATAS.second_if_nominee_minor &&
      data.second_nominee_relationship ==
        state.ESIdetails.ESIDATAS.second_nominee_relationship &&
      data.second_nominee_dob == state.ESIdetails.ESIDATAS.second_nominee_dob &&
      concatenatedSecondProcessed == nomineeNameAddressPsecondrocessed &&
      data.previous_ESI_number ==
        state.ESIdetails.ESIDATAS.previous_ESI_number &&
      data.third_if_nominee_minor ==
        state.ESIdetails.ESIDATAS.third_if_nominee_minor &&
      data.third_nominee_dob == state.ESIdetails.ESIDATAS.third_nominee_dob &&
      concatenatedthirdonerocessed == NomieesThirdNameAndAddress &&
      data.third_nominee_relationship ==
        state.ESIdetails.ESIDATAS.third_nominee_relationship &&
      data.third_percentage == state.ESIdetails.ESIDATAS.third_percentage &&
      data.third_total_amount == state.ESIdetails.ESIDATAS.third_total_amount &&
      data.fourth_if_nominee_minor ==
        state.ESIdetails.ESIDATAS.fourth_if_nominee_minor &&
      data.fourth_nominee_dob == state.ESIdetails.ESIDATAS.fourth_nominee_dob &&
      concatenatedFourthonerocessed == NomieesFourthNameAndAddress &&
      data.fourth_nominee_relationship ==
        state.ESIdetails.ESIDATAS.fourth_nominee_relationship &&
      data.fourth_percentage == state.ESIdetails.ESIDATAS.fourth_percentage &&
      data.fourth_total_amount == state.ESIdetails.ESIDATAS.fourth_total_amount
    ) {
      // dispatch(SetActiveTabs(12));
      if (a == 0) {
        Navigate("/employeeprofile");
        setcount(2);
      }
    }

    console.log(a, "0193qwepoqwie");
  };

  const HandleVerify = () => {
    Swal.fire({
      title: "Are you sure, do you want to  Verify?",
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Verify it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire(
        //   "Deleted!",
        //   "Given Info has been deleted.",
        //   "success"
        // );

        // console.log(state.EmployeeProfile.EmployeeProfileList, "userId");
        if (
          state.EmployeeProfile.EmployeeProfileList != undefined ||
          (state.EmployeeProfile.EmployeeProfileList != null &&
            state.EmployeeProfile.EmployeeProfileList.lenght > 0 &&
            state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
            state.EmployeeProfile.EmployeeProfileList.user_id.id != undefined)
        ) {
          console.log(SubRoleList, "SubRoleList");
          const payload = {
            UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
            //is_pending: true,
            is_pending: SubRoleList == 0 ? true : false,
            is_decline: false, ///is_decline :have to be true when the Rm is need to approve
            create_employee: true,
            Decline: 0,
            payroll_approved:
              SubRoleList == 0 || SubRoleList == 3 ? true : true,
          };
          dispatch(SetApprovalCallsActions(payload));
          if (SubRoleList == 1 || SubRoleList == 3) {
            navigate("/verifystatus");
          } else {
            navigate("/employeeVerifylist");
          }
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  ////------------------Declines-------------------------
  const HandleDecline = () => {
    Swal.fire({
      title: "Are you sure, do you want to Decline?",
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Decline it!",
      input: "text",
      inputPlaceholder: "Reason for decline...",
      inputValidator: (value) => {
        if (!value) {
          return "You need to provide a reason for declining";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const reason = result.value; // Retrieve the value entered by the user
        const payload = {
          UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
          is_pending: true,
          is_decline: true,
          Decline: 1,
          payroll_approved: SubRoleList == 0 ? false : false,
          reason_for_decline: reason, // Include the reason in the payload
        };
        // console.log(payload , "payload");

        dispatch(SetApprovalCallsActions(payload));
        // DateOfJoing
        navigate("/employeeVerifylist");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          text: " Employee verification as been cancel",
          icon: "error",
        });
        Swal.close();
      }
    });
  };

  const handleAddFields = () => {
    var Numbercheck = 0;
    if (Numberoffields + 1 == 2) {
      if (data.NameOfNomiees == "") {
        setnoimeeErr("*Nominee name is  required");
        Numbercheck = 1;
      }

      if (data.AddressOf_nomoiees == "") {
        Numbercheck = 1;
        setNoimerr("*Nominee Address is required");
      }
      if (data.nominee_dob == "" || data.nominee_dob == null) {
        Numbercheck = 1;
        setnoimeeDobErr("*Nominee DOB  is required");
      }

      if (
        data.nominee_relationship == "" ||
        data.nominee_relationship == null
      ) {
        Numbercheck = 1;
        setnoimeerr("*Nominee Relationship  is required");
      }

      if (data.if_nominee_minor == "" || data.if_nominee_minor == null) {
        Numbercheck = 1;
        setIfnoimeeErr("*Please enter the details");
      }

      if (data.percentage == "") {
        Numbercheck = 1;
        setTotalErr("*Share amount is required");
      }

      // if (Presentimages[0] ==  null ||Presentimages[0] == undefined || Presentimages[0] == '') {

      //   setNomieeImageError("*Nominee image is required")
      //   Numbercheck= 1;
      // }
    }
    if (Numberoffields + 1 == 3) {
      if (data.secondNomiees == "") {
        setsecondNomieesError("*Second Nominee name  is  required");
        Numbercheck = 1;
      }

      if (data.AddressOf_second_nomoiee == "") {
        Numbercheck = 1;
        SetAddressOf_second_nomoieeError("*Second Nominee Address is required");
      }

      if (data.second_nominee_dob == "" || data.second_nominee_dob == null) {
        Numbercheck = 1;
        setsecond_nominee_dobError("*Second Nominee DOB  is required");
      }

      if (
        data.second_nominee_relationship == "" ||
        data.second_nominee_relationship == null
      ) {
        Numbercheck = 1;
        setRelationError("*Second Nominee Relationship  is required");
      }
      if (data.second_nominee_dob == "" || data.second_nominee_dob == null) {
        Numbercheck = 1;
        setsecond_nominee_dobError("*Second Nominee DOB  is required");
      }

      if (
        data.second_if_nominee_minor == "" ||
        data.second_if_nominee_minor == null
      ) {
        Numbercheck = 1;
        setIfsecondErro("*Please enter the details");
      }
      if (
        data.second_total_amount === "" &&
        data.second_total_amount !== 0 &&
        data.second_total_amount == null
      ) {
        Numbercheck = 1;

        setSecondNomieTotal("*Share amount is required");
      }
      // if (Presentimages[1] ==  null ||Presentimages[1] == undefined || Presentimages[1] == '') {

      //   setNomieeSecondImageError("*Second nominee image is required")
      //   Numbercheck = 1;
      // }
    }
    if (Numberoffields + 1 == 4) {
      if (data.NameofthidNomirr === "" || data.NameofthidNomirr == null) {
        setThirdNomineesError("*Third Nominee name is required");
        Numbercheck = 1;
      }

      if (
        data.addressofthirdnomiee === "" ||
        data.addressofthirdnomiee == null
      ) {
        setAddressOf_third_nomineeError("*Third Nominee Address is required");
        Numbercheck = 1;
      }

      if (data.third_nominee_dob === "" || data.third_nominee_dob == null) {
        setThird_nominee_dobError("*Third Nominee DOB is required");
        Numbercheck = 1;
      }

      if (
        data.third_nominee_relationship === "" ||
        data.third_nominee_relationship == null
      ) {
        setThirdRelationError("*Third Nominee Relationship is required");
        Numbercheck = 1;
      }

      if (
        data.third_if_nominee_minor === "" ||
        data.third_if_nominee_minor == null
      ) {
        setIfThirdError("*Please enter the details");
        Numbercheck = 1;
      }
      if (
        data.third_total_amount === "" &&
        //  data.third_total_amount !== 0 ||
        data.third_total_amount == null
      ) {
        setIfThirdTotalError("*Share amount is required");
        Numbercheck = 1;
      }
      // if (Presentimages[2] ==  null ||Presentimages[2] == undefined || Presentimages[2] == "") {

      //   setNomieeThirdImageError("*Third nominee image is required")
      //   Numbercheck = 1;
      // }
    }
    console.log(
      Numberoffields,
      "Numberoffields , Numbercheck == 1?  second , ",
      Numbercheck,
    );

    if (Numberoffields == 1 && Numbercheck == 0) {
      if (data?.second_total_amount == null) {
        setData({
          ...data,
          second_total_amount: 0,
          second_percentage: 0,
        });
      }
    }
    if (Numberoffields == 2 && Numbercheck == 0) {
      if (data?.third_total_amount == null) {
        setData({
          ...data,
          third_total_amount: 0,
          third_percentage: 0,
        });
      }
    }

    if (Numberoffields == 3 && Numbercheck == 0) {
      if (data?.fourth_total_amount == null) {
        setData({
          ...data,
          fourth_total_amount: 0,
          fourth_percentage: 0,
        });
      }
    }

    if (Numbercheck == 0) {
      setNumberOfFileds(Numberoffields + 1);
      let newField = Numberoffields + 1;
      setInputFields((prevState) => ({
        ...prevState,
        InputFieldsNum: [...prevState.InputFieldsNum, newField],
      }));
    }
  };
  console.log(data, "asodiasidua sdoisudas di", Numberoffields);

  const handleRemoveFieldsNumbers = (numberToRemove) => {
    if (Numberoffields > 0) {
      setNumberOfFileds(Numberoffields - 1);
      setInputFields((prevState) => ({
        ...prevState,
        InputFieldsNum: prevState.InputFieldsNum.filter(
          (num) => num !== numberToRemove,
        ),
      }));
    }
  };

  const getFilteredOptions = (currentNomineeValue) => {
    const selectedValues = [
      parseInt(totalAmountSelect?.value, 10) || 0,
      parseInt(TotalNomiees?.value, 10) || 0,
      parseInt(ThirdNomieeOptions?.value, 10) || 0,
      parseInt(fourtheNomie?.value, 10) || 0,
    ];

    // Calculate the total allocated percentage
    const totalAllocated = selectedValues.reduce(
      (sum, value) => sum + value,
      0,
    );

    // Filter options based on available remaining percentage (100 - totalAllocated)
    return OptionsForNomiees.filter((option) => {
      const optionValue = parseInt(option.value, 10);

      // Always include "0%" or the current nominee value
      if (
        option.value === "0" ||
        optionValue === parseInt(currentNomineeValue, 10)
      ) {
        return true;
      }

      // Exclude options that would push the total over 100%
      return optionValue <= 100 - totalAllocated;
    });
  };

  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], "croppedimg.jpg", {
          type: "image/jpeg",
        });
        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false);
          }, 0);
        }

        setImageFileChange((prevState) => {
          const newState = [...prevState];
          newState[forindex] = true;
          return newState;
        });

        const updatedImagesFile = [...imagesFile];

        updatedImagesFile[forindex] = croppedFile;
        setImagesFile(updatedImagesFile);
        const generateRandomNumber = (digits = 12) => {
          const min = 10 ** (digits - 1);
          const max = 10 ** digits;
          return Math.floor(min + Math.random() * (max - min));
        };

        const fileNameWithoutExtension = croppedFile.name.split(".")[0];

        console.log(forindex, "ouauyeiuqywforindex");

        const createPresentData = (croppedFile) => {
          const randomNumber = generateRandomNumber();
          const formattedFilename = `onboarding/${"nomineeimage"}/${fileNameWithoutExtension}${randomNumber}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
          const Presentdata = {
            multiple_files: [
              {
                filename: formattedFilename,
                file_type: croppedFile.type,
              },
            ],
          };

          return Presentdata;
        };

        const Presentdata = createPresentData(croppedFile);

        axios({
          url: PresentUrl,
          method: "post",
          data: Presentdata,
          headers: {
            Authorization:
              "Bearer " + store.getState().users.UserData.session.token,
          },
        })
          .then((response) => {
            // console.log('Files uploaded successfully:', response.data);
            const uploadedFiles = response.data.data; // Adjust based on actual response structure
            // console.log(uploadedFiles ,"uploadedFiles");

            const newUrls = uploadedFiles.map((file) => ({
              url: file, // Adjust this based on the actual response
              type: croppedFile.type,
              putfiles: croppedFile,
            }));
            setPresentUrls((prevUrls) => {
              const updatedUrls = [...prevUrls];
              updatedUrls[forindex] = newUrls[0];
              return updatedUrls;
            });

            const Urls = uploadedFiles.map((file) => ({
              url: file,
            }));

            const updatedImagespreFile = [...Presentimages];

            updatedImagespreFile[forindex] = String(response.data.data).split(
              "?",
            )[0];
            setPresentImages(updatedImagespreFile);
          })
          .catch((error) => {
            console.error("Error uploading files:", error);
          });

        var file = croppedFile;
        var reader = new FileReader();
        reader.onloadend = function () {
          setImages((prevImages) => {
            const newImages = [...prevImages];
            newImages[forindex] = reader.result;
            return newImages;
          });

          if (updatedst) {
            setUpdateImage((prevState) => {
              const newState = [...prevState];
              newState[forindex] = true;
              return newState;
            });
          }
        };
        reader.readAsDataURL(file);
        blob.name = fileName;
        let fileUrl = window.URL.createObjectURL(blob);
        console.log(fileUrl);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  }

  const handleFileChange = (event, index, update = false) => {
    const file = event.target.files[0];
    console.log(file, "file");
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;
    setCroppImageView(true);
    setalert(true);
    setupdatest(update);
    setCroppImageViewCount(index);

    setEducationFiles(event);

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
            selectedImage(event, index);
          });
        });
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      // e.target.value = ""; // Clear the file input
    }
  };

  const updateAvatar = (imgSrc) => {
    fileInputRef.current.value = imgSrc;
  };

  console.log(
    state.ClientBranchIDs.SUBROLE,
    "PasChec",
    state.NumberCounts.EmployeeFormFIll,
  );

  return (
    <>
      <div>
        <div>
          <div className=" BodyContent">
            <div className="card">
              <div className="card-body cards ">
                <div className="UserPoup">
                  <div className="BeforForms">
                    <div className="Form">
                      <div className="ModalHeader">
                        <div>
                          <span>ESI Form</span>
                        </div>
                      </div>

                      <div className="Modal-Body ModalForms">
                        <div className="row">
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Name<span style={{ color: "red" }}>*</span>
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="employee_name"
                              value={data.employee_name}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                // HandleChanges(e);
                                // setEmpNaErr("");
                                if (e.target.value.length < 150) {
                                  HandleChanges(e);
                                  setEmpNaErr("");
                                  setErrInde(0);
                                } else {
                                  setErrInde(1);
                                  setEmpNaErr(
                                    "Name should not exit  more than the 150 characters",
                                  );
                                }
                              }}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {empNameerr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label class="form-label CheckboxLabels">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                onChange={(e) => {
                                  if (data.gender == "Male") {
                                    handleCheckChnages(
                                      e,
                                      "father",
                                      true,
                                      false,
                                    );
                                    setFaErr("");
                                  } else if (data.gender == "Female") {
                                    handleCheckChnages(
                                      e,
                                      "father",
                                      true,
                                      false,
                                    );
                                    setFaErr("");
                                  } else if (data.gender == "other") {
                                    handleCheckChnages(
                                      e,
                                      "father",
                                      true,
                                      false,
                                    );
                                    setFaErr("");
                                  }
                                }}
                                checked={PasChec.Father}
                                style={{ cursor: "pointer" }}
                              />
                              Father
                              {PasChec.Father ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="father_husband_name"
                              // value={data.father_husband_name}
                              value={data.FatherName}
                              style={{ height: "37px" }}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 0 &&
                                state.ClientBranchIDs.SUBROLE != 1 &&
                                state.ClientBranchIDs.SUBROLE != 3 &&
                                PasChec.Father == false
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3 &&
                                      PasChec.Father == true
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                        PasChec.Father == true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            false &&
                                          PasChec.Father == false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              true &&
                                            state.ClientBranchIDs.SUBROLE ==
                                              1 &&
                                            PasChec.Father == true
                                          ? false
                                          : state.NumberCounts.Editable == 2 &&
                                              PasChec.Father == true
                                            ? false
                                            : true
                              }
                              // readOnly={showField}

                              onChange={(e) => {
                                // HandleChanges(e);
                                setData({
                                  ...data,
                                  FatherName: e.target.value
                                    .toUpperCase()
                                    .trim(),
                                });
                                setFatherErr("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {FatherErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label
                              class="form-label CheckboxLabels"
                              style={{ width: "100%" }}
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                onChange={(e) => {
                                  console.log(data.gender, "data.gender");

                                  if (data.gender == "Female") {
                                    handleCheckChnages(
                                      e,
                                      "husband",
                                      false,
                                      true,
                                    );
                                    setFatherErr("");
                                  } else if (
                                    data.gender == "other" ||
                                    data?.marital_status == "others"
                                  ) {
                                    handleCheckChnages(
                                      e,
                                      "husband",
                                      false,
                                      true,
                                    );
                                    setFatherErr("");
                                  }
                                }}
                                checked={PasChec.husband}
                                style={{ cursor: "pointer" }}
                              />
                              Husband
                              {PasChec.husband ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="father_husband_name"
                              // value={data.father_husband_name}
                              value={data.FatherORHUSBANDNAME}
                              style={{ height: "37px" }}
                              // readOnly={
                              //   state.NumberCounts.Editable == 1 &&
                              //     state.ClientBranchIDs.SUBROLE != 3
                              //     ? true
                              //     : PasChec.husband == false
                              //       ?
                              //       true :
                              //       false
                              // }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 0 &&
                                state.ClientBranchIDs.SUBROLE != 1 &&
                                state.ClientBranchIDs.SUBROLE != 3 &&
                                PasChec.husband == false
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3 &&
                                      PasChec.husband == true
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                        PasChec.husband == true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            false &&
                                          PasChec.husband == false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              true &&
                                            state.ClientBranchIDs.SUBROLE ==
                                              1 &&
                                            PasChec.husband == true
                                          ? false
                                          : state.NumberCounts.Editable == 2 &&
                                              PasChec.husband == true
                                            ? false
                                            : true
                              }
                              // readOnly={showField && PasChec.husband ? false : true }

                              onChange={(e) => {
                                // HandleChanges(e);
                                setData({
                                  ...data,
                                  FatherORHUSBANDNAME: e.target.value
                                    .toUpperCase()
                                    .trim(),
                                });
                                setFaErr("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {FaNErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Date of Birth
                            </label>
                            <input
                              type="date"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="date_of_birth"
                              value={data.date_of_birth}
                              // readOnly={
                              //   state.NumberCounts.Editable == 1 &&
                              //     state.ClientBranchIDs.SUBROLE != 3
                              //     ? true
                              //     : false
                              // }
                              // disabled={
                              //   state.NumberCounts.Editable == 1 &&
                              //     state.ClientBranchIDs.SUBROLE != 3
                              //     ? true
                              //     : false
                              // }
                              disabled={
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setDateBErr("");
                              }}
                              onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                              onKeyDown={preventTyping}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {dateBErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <br />

                            <label for="validationCustom01" class="form-label">
                              Gender
                            </label>
                            {state.NumberCounts.Editable == 1 ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )}
                            <div className="col">
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="Male"
                                  id="flexCheckDefault"
                                  name="gender"
                                  checked={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? ForGender.Male
                                      : data.gender == "Male"
                                        ? true
                                        : false
                                  }
                                  readOnly={
                                    (state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 2) ||
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setGenderErr("");
                                  }}
                                  disabled={
                                    (state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 2) ||
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                />
                                <label class="form-check-label">Male</label>
                              </div>
                              <div
                                class="form-check d-inline"
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="Female"
                                  id="flexCheckChecked"
                                  name="gender"
                                  checked={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? ForGender.Female
                                      : data.gender == "Female"
                                        ? true
                                        : false
                                  }
                                  readOnly={
                                    (state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 2) ||
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                  }}
                                  disabled={
                                    (state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 2) ||
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                />
                                <label
                                  class="form-check-label"
                                  for="flexCheckChecked"
                                >
                                  Female
                                </label>
                              </div>
                              <div
                                class="form-check  d-inline "
                                style={{ marginRight: "13px" }}
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value="Others"
                                  id="flexCheckChecked"
                                  name="gender"
                                  checked={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? ForGender.other
                                      : data.gender == "Others"
                                        ? true
                                        : false
                                  }
                                  readOnly={
                                    (state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 2) ||
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                  }}
                                  disabled={
                                    (state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 2) ||
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                />
                                <label
                                  class="form-check-label"
                                  for="flexCheckChecked"
                                >
                                  other
                                </label>
                              </div>
                            </div>
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {GenderErr}
                            </p>
                          </div>

                          <div className="col mt-3">
                            <label for="validationCustom01" class="form-label">
                              Marital Status
                            </label>
                            <Select
                              class="form-control "
                              name="marital_status"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 0 &&
                                state.ClientBranchIDs.SUBROLE != 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              true &&
                                            state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              isDisabled={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 0 &&
                                state.ClientBranchIDs.SUBROLE != 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              true &&
                                            state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              onChange={(e) => {
                                setMaritalStatus(e);
                                console.log(e.value, "e.value");

                                let updatedData = {
                                  ...data,
                                  marital_status: e.value,
                                };

                                // if (data?.gender != "Male" && e.value == "married") {
                                //   setPassChe({
                                //     ...PasChec,
                                //     Father: false,
                                //     husband: true,
                                //   });
                                //   updatedData = {
                                //     ...updatedData,
                                //     FatherName: "",  // clear father name
                                //   };
                                // }
                                if (data?.gender == "Male") {
                                  if (
                                    (data?.gender == "Male" &&
                                      e.value == "unmarried") ||
                                    e.value == "married"
                                  ) {
                                    setPassChe({
                                      ...PasChec,
                                      Father: true,
                                      husband: false,
                                    });
                                    updatedData = {
                                      ...updatedData,
                                      FatherORHUSBANDNAME: "", // clear husband/father field
                                    };
                                  } else if (
                                    data?.gender == "Male" &&
                                    e.value == "unmarried"
                                  ) {
                                    setPassChe({
                                      ...PasChec,
                                      Father: true,
                                      husband: false,
                                    });
                                    updatedData = {
                                      ...updatedData,
                                      FatherORHUSBANDNAME: "", // clear husband/father field
                                    };
                                  }
                                }
                                setData(updatedData);
                                setMatriErr("");
                              }}
                              options={Options}
                              value={MaterilStatus}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {maritalStErr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Account Number
                            </label>
                            {/* <input
                              type="number"
                              // onKeyDown={(evt) =>
                              //   ["e", "E", "+", "-"].includes(evt.key) &&
                              //   evt.preventDefault()
                              // }
                              step="1"
                              onKeyDown={(evt) => {
                                if (["e", "E", "+", "-", "."].includes(evt.key)) {
                                  evt.preventDefault();
                                }
                              }}
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="account_number"
                              value={data.account_number}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setAccountErr("");
                              }}
                            /> */}
                            <input
                              type="number"
                              step="1"
                              onKeyDown={preventZoom}
                              onPaste={handlePaste}
                              onWheel={preventZoom}
                              ref={inputRef}
                              className="form-control"
                              id="validationCustom01"
                              autoComplete="off"
                              name="account_number"
                              value={data.account_number}
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue <= 0) {
                                  setAccountErr(
                                    "*Account number must be greater than 0.",
                                  );
                                  setErrInde(1);
                                  e.target.value = "";
                                } else if (inputValue.length > 100) {
                                  setAccountErr(
                                    "*Account number must not exceed 100 digits.",
                                  );
                                  setErrInde(1);
                                } else if (inputValue.length <= 8) {
                                  setAccountErr(
                                    "*Account number must be more than 8 digits.",
                                  );
                                  setErrInde(1);
                                } else {
                                  setAccountErr("");
                                  setErrInde(0);
                                }
                                HandleChanges(e);
                              }}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {AccounNumberErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Address Permanent
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="address_permanent"
                              value={data.address_permanent}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setAddressPerErr("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {AddressPerErr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Address Temporary
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="address_temporary"
                              value={data.address_temporary}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setAddretemErr("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {AddressTEMPOERR}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Date of Joining
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="date"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="date_of_joining"
                              value={data.date_of_joining}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 0 &&
                                state.ClientBranchIDs.SUBROLE != 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              true &&
                                            state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 0 &&
                                state.ClientBranchIDs.SUBROLE != 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                            false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              true &&
                                            state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              min={
                                EmailID == "admin@gmail.com" ||
                                EmailID == "admin@qpms.in"
                                  ? ""
                                  : formattedMinDate
                              }
                              onFocus={(e) => {
                                e.target.showPicker();
                              }} // Programmatically trigger the date picker on focus
                              max={
                                EmailID == "admin@gmail.com" ||
                                EmailID == "admin@qpms.in"
                                  ? // state.ClientBranchIDs.SUBROLE == 3
                                    ""
                                  : formattedMaxDate
                              }
                              // min={new Date().toISOString().split("T")[0]} // Set the min attribute to today's date
                              onChange={(e) => {
                                HandleChanges(e);
                                setDateErr("");
                              }}
                              onKeyDown={preventTyping}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {DateJErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              E.P.F
                            </label>
                            <input
                              type="number"
                              step="1"
                              onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                              onPaste={handlePaste} // Handle pasting
                              onWheel={preventZoom} // Prevent zooming with the mouse wheel
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="e_p_f"
                              value={data.e_p_f}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setEpFErr("");
                              }}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              E.P.S
                            </label>
                            <input
                              type="number"
                              step="1"
                              onKeyDown={preventZoom} // Prevent zoom and unwanted keys
                              onPaste={handlePaste} // Handle pasting
                              onWheel={preventZoom} // Prevent zooming with the mouse wheel
                              className="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="e_p_s"
                              value={data.e_p_s}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                              }}
                            />
                            {/* <p className="Error" style={{ marginLeft: "-5px" }}>
                              {EpsERR}
                            </p> */}
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              ESI Number
                            </label>
                            <input
                              type="number"
                              // onKeyDown={(evt) =>
                              //   ["e", "E", "+", "-"].includes(evt.key) &&
                              //   evt.preventDefault()
                              // }
                              step="1"
                              onKeyDown={preventZoom}
                              onPaste={handlePaste}
                              onWheel={preventZoom}
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="previous_ESI_number"
                              value={data.previous_ESI_number}
                              readOnly={
                                // state.NumberCounts.Editable == 1 &&
                                //   state.ClientBranchIDs.SUBROLE != 3
                                //   ? true
                                //   : false
                                state.NumberCounts.Editable == 1
                                  ? state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 1 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          false
                                      ? true
                                      : false
                                  : state.NumberCounts.EmployeeFormFIll == true
                                    ? false
                                    : true
                              }
                              // onChange={(e) => {
                              //   HandleChanges(e);
                              // }}
                              onChange={(e) => {
                                const value = e.target.value;
                                const phoneRegex = /^[0-9]{0,10}$/;

                                // const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                setpreviousESi("");
                                //  if(isNaN(e.target.value) ==  false){
                                if (
                                  value.length <= 10 &&
                                  (phoneRegex.test(value) || value === "")
                                ) {
                                  HandleChanges(e);
                                }
                                // }
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {previosueEsi}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              ESI Dispensary
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="esi_dispensary"
                              value={data.esi_dispensary}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setEpsErr("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {EpsERR}
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-12 p-0"
                          style={{ marginTop: "20px" }}
                        >
                          <label
                            className="form-label-Header"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            PART-A (E.P.F)
                            <button
                              className="verify ButtonCSS"
                              style={{
                                background: "#234492",
                                padding: "7px 9px",
                              }}
                              disabled={
                                (state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3) ||
                                inputFields.InputFieldsNum.length == 3
                                  ? true
                                  : state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : false
                              }
                              onClick={(index) => {
                                handleAddFields(Numberoffields);
                              }}
                            >
                              Add Nominee
                            </button>
                          </label>
                        </div>
                        <>
                          <div className="row">
                            <div className="col-sm-3 mt-3">
                              <br />
                              <br />
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Name of the Nominee
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="NameOfNomiees"
                                value={data.NameOfNomiees}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setnoimeeErr("");
                                }}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {/* {nomierN} */}
                                {/* {NomieeErr} */}
                                {NomieerrSelctErr}
                              </p>
                            </div>

                            <div className="col-sm-3 mt-3">
                              <br />
                              <br />

                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Address of the Nominee
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="AddressOf_nomoiees"
                                value={data.AddressOf_nomoiees}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setNoimerr("");
                                }}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {NomieeErr}
                              </p>
                            </div>

                            <div className="col-sm-3 mt-3">
                              <br />
                              <br />
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Nominee Relationship with the members
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                options={OptionsFam}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                value={NomieeFirst}
                                onChange={(e) => {
                                  setnomieeFirst(e);
                                  setnoimeerr("");
                                  if (e != null && e != undefined) {
                                    setData({
                                      ...data,
                                      nominee_relationship: e.label,
                                    });
                                  }
                                }}
                              />

                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {nomierN}
                              </p>
                            </div>

                            <div className="col-sm-3 mt-3">
                              <br />

                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Total Amount or Share of accumulations in
                                Provident Fund to be paid to each nominee
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                // options={OptionsForNomiees}
                                options={
                                  totalAmountSelect?.value ||
                                  TotalNomiees?.value ||
                                  ThirdNomieeOptions?.value ||
                                  fourtheNomie?.value
                                    ? getFilteredOptions(
                                        totalAmountSelect?.value,
                                      )
                                    : OptionsForNomiees
                                }
                                name="total_amount"
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                isDisabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : data.third_total_amount == 100 ||
                                        data.fourth_total_amount == 100 ||
                                        data.second_total_amount == 100
                                      ? true
                                      : false
                                }
                                value={totalAmountSelect}
                                onremoved={(e) => {
                                  setTotalAmount(e);
                                }}
                                onChange={(e) => {
                                  HandleTotalAmounts(e, 0);
                                  setTotalAmount(e);
                                  setTotalErr("");
                                }}
                              />

                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {TotalNumErr}
                              </p>
                            </div>
                            <div className="col-sm-3 mt-5">
                              <br />
                              <br />

                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Nominee DOB
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="date"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="nominee_dob"
                                max={today}
                                value={data.nominee_dob}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setnoimeeDobErr("");
                                }}
                                onFocus={(e) => e.target.showPicker()}
                                onKeyDown={preventTyping}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {noimeeDobErr}
                              </p>
                            </div>

                            <div className="col-sm-3 mt-5">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                If the Nominee is a minor, name and address of
                                the guardian who may receive the amount during
                                the minority of the nominee
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="if_nominee_minor"
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setIfnoimeeErr("");
                                }}
                                value={data.if_nominee_minor}
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {ifNoimeeErr}
                              </p>
                            </div>
                            <div className="col-6 mt-4 centerElement">
                              <label>
                                {" "}
                                Upload the picture for the nominee
                                {/* <span style={{ color: "red" }}>*</span> */}
                                <small
                                  style={{
                                    color: "red",
                                    marginLeft: "12px",
                                    display: "block",
                                  }}
                                >
                                  Note:Upload the picture, please. Verify that
                                  the file is in the JPG, JPEG, or PNG format
                                  and that its size is less than 10 MB.
                                </small>
                              </label>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "flex-start",
                                  gap: "10px",
                                  flexDirection: "column",
                                }}
                              >
                                {images[0] && (
                                  <img
                                    src={images[0]}
                                    alt="test2"
                                    style={{
                                      width: "198px",
                                      height: "153px",
                                      borderRadius: "12px",
                                      border: "4px solid #234492",
                                    }}
                                  />
                                )}
                                <div
                                  className="w-100 d-flex "
                                  style={{
                                    gap: "12px",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Button
                                    className="doctorupload"
                                    component="label"
                                    role={undefined}
                                    variant="contained"
                                    tabIndex={-1}
                                    sx={{
                                      backgroundColor: "#234492",
                                      fontSize: "11px !important",
                                      "&:hover": {
                                        backgroundColor: "#e74c3c",

                                        opacity: "0.8",
                                      },
                                    }}
                                    style={{
                                      width: "fit-content",
                                      color: "#fff",
                                    }}
                                    onChange={(e) => {
                                      setforindex(0);
                                      handleFileChange(e, 0);
                                      setNomieeImageError("");
                                    }}
                                    disabled={
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                        ? false
                                        : state.NumberCounts.EmployeeFormFIll ==
                                              false &&
                                            state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                    }
                                  >
                                    {images[0] ? "Update Image" : "Upload file"}

                                    <VisuallyHiddenInput
                                      type="file"
                                      ref={fileInputRef}
                                    />
                                  </Button>
                                  <Downloads_doc url={images[0]} />
                                </div>
                              </div>
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {NomieeeImageError}
                              </p>
                            </div>
                          </div>
                        </>
                        {inputFields.InputFieldsNum.includes(2) ? (
                          <>
                            <div
                              className=" btn  StatusList"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignContent: "center",
                                gap: "20px",
                              }}
                            >
                              <div
                                className="DeclineStatus"
                                onClick={(e) => {
                                  if (
                                    state.NumberCounts.Editable == 2 ||
                                    state.ClientBranchIDs.SUBROLE == 3
                                  ) {
                                    setnomieesecond();
                                    setTotalNomiees({
                                      value: "0",
                                      label: `0`,
                                    });

                                    setData({
                                      ...data,
                                      second_total_amount: null,
                                      second_nominee_name_address: null,
                                      second_nominee_relationship: null,
                                      second_if_nominee_minor: null,
                                      second_nominee_dob: null,
                                      secondNomiees: "",
                                      AddressOf_second_nomoiee: "",
                                    });
                                    handleRemoveFieldsNumbers(2);
                                    setNomieeSecondImageError("");
                                  }
                                }}
                              >
                                <span>x</span>
                              </div>
                            </div>

                            <div className="row" style={{ marginTop: "10px" }}>
                              <div className="col-sm-3 mt-3">
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Name of Second Nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="secondNomiees"
                                  value={data.secondNomiees}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setsecondNomieesError("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {secondNomieesErr}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Address of the Second nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="AddressOf_second_nomoiee"
                                  value={data.AddressOf_second_nomoiee}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    SetAddressOf_second_nomoieeError("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {AddressOf_second_nomoieeError}
                                </p>
                              </div>
                              <div className="col-sm-3 mt-3">
                                <br />

                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Second Nominee Relationship with the members
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  options={OptionsFam}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  value={Nomieesecond}
                                  onChange={(e) => {
                                    setnomieesecond(e);
                                    setRelationError("");
                                    if (e != null && e != undefined) {
                                      setData({
                                        ...data,
                                        second_nominee_relationship: e.label,
                                      });
                                    }
                                  }}
                                />

                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {SecondRelationError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Total Amount or Share of accumulations in
                                  Provident Fund to be paid to each nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>

                                <Select
                                  // options={OptionsForNomiees}
                                  options={
                                    totalAmountSelect?.value ||
                                    TotalNomiees?.value ||
                                    ThirdNomieeOptions?.value ||
                                    fourtheNomie?.value
                                      ? getFilteredOptions(TotalNomiees?.value)
                                      : OptionsForNomiees
                                  }
                                  name="second_total_amount"
                                  value={TotalNomiees}
                                  isDisabled={
                                    data.third_total_amount == 100 ||
                                    data.fourth_total_amount == 100 ||
                                    data.total_amount == 100
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    setSecondNomieTotal("");
                                    HandleTotalAmounts(e, 1);
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {SecondNomieeTotal}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-4">
                                <br />
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Second Nominee Date Of Birth
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="date"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  // min="1925-01-01"
                                  // max="2004-12-01"
                                  max={today} // Set the max attribute to today's date
                                  name="second_nominee_dob"
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setsecond_nominee_dobError("");
                                  }}
                                  value={data.second_nominee_dob}
                                  onKeyDown={preventTyping}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {second_nominee_dobError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-4">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  If the Second Nominee is a minor, name and
                                  address of the guardian who may receive the
                                  amount during the minority of the nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="second_if_nominee_minor"
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setIfsecondErro("");
                                  }}
                                  value={data.second_if_nominee_minor}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {ifsecondError}
                                </p>
                              </div>
                              <div className="col-6 mt-4 centerElement">
                                <label>
                                  {" "}
                                  Upload the picture for the second nominee
                                  {/* <span style={{ color: "red" }}>*</span> */}
                                  <small
                                    style={{
                                      color: "red",
                                      marginLeft: "12px",
                                      display: "block",
                                    }}
                                  >
                                    Note:Upload the picture, please. Verify that
                                    the file is in the JPG, JPEG, or PNG format
                                    and that its size is less than 10 MB.
                                  </small>
                                </label>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    gap: "10px",
                                    flexDirection: "column",
                                  }}
                                >
                                  {images[1] && (
                                    <img
                                      src={images[1]}
                                      alt="test2"
                                      style={{
                                        width: "198px",
                                        height: "153px",
                                        borderRadius: "12px",
                                        border: "4px solid #234492",
                                      }}
                                    />
                                  )}
                                  <div
                                    className="w-100 d-flex "
                                    style={{
                                      gap: "12px",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Button
                                      className="doctorupload"
                                      component="label"
                                      role={undefined}
                                      variant="contained"
                                      tabIndex={-1}
                                      sx={{
                                        backgroundColor: "#234492",
                                        fontSize: "11px !important",
                                        "&:hover": {
                                          backgroundColor: "#e74c3c",

                                          opacity: "0.8",
                                        },
                                      }}
                                      onChange={(e) => {
                                        setforindex(1);
                                        handleFileChange(e, 1);
                                        setNomieeSecondImageError("");
                                        setPresentImages([
                                          Presentimages[0],
                                          null,
                                          Presentimages[2],
                                          Presentimages[3],
                                        ]);
                                      }}
                                      style={{
                                        width: "fit-content",
                                        color: "#fff",
                                      }}
                                      disabled={
                                        state.NumberCounts.EmployeeFormFIll ==
                                        true
                                          ? false
                                          : state.NumberCounts
                                                .EmployeeFormFIll == false &&
                                              state.ClientBranchIDs.SUBROLE == 3
                                            ? false
                                            : true
                                      }
                                    >
                                      {images[1]
                                        ? "Update Image"
                                        : "Upload file"}

                                      <VisuallyHiddenInput
                                        type="file"
                                        ref={fileInputRef}
                                      />
                                    </Button>
                                    <Downloads_doc url={images[1]} />
                                  </div>
                                </div>
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {NomieeeSecondImageError}
                                </p>
                              </div>
                            </div>
                          </>
                        ) : null}
                        {/* ///--third ===nomieee */}
                        {inputFields.InputFieldsNum.includes(3) ? (
                          <>
                            <div
                              className=" btn  StatusList"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignContent: "center",
                                gap: "20px",
                              }}
                            >
                              <div
                                className="DeclineStatus"
                                onClick={(e) => {
                                  if (
                                    state.NumberCounts.Editable == 2 ||
                                    state.ClientBranchIDs.SUBROLE == 3
                                  ) {
                                    setData({
                                      ...data,
                                      third_if_nominee_minor: null,
                                      third_nominee_dob: null,
                                      third_nominee_name_address: null,
                                      third_nominee_relationship: null,
                                      third_percentage: null,
                                      third_total_amount: null,
                                      NameofthidNomirr: "",
                                      addressofthirdnomiee: "",
                                    });
                                    setThirdNomieeOptFam();
                                    setThirdNomieeOpt({
                                      value: "0",
                                      label: "0",
                                    });
                                    setPresentImages([
                                      Presentimages[0],
                                      Presentimages[1],
                                      null,
                                      Presentimages[3],
                                    ]);
                                    handleRemoveFieldsNumbers(3);
                                  }
                                }}
                              >
                                <span>x</span>
                              </div>
                            </div>

                            <div className="row" style={{ marginTop: "10px" }}>
                              <div className="col-sm-3 mt-3">
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Name of Third Nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="NameofthidNomirr"
                                  value={data.NameofthidNomirr}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setThirdNomineesError("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {thirdNomineesErr}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Address of the Third nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="addressofthirdnomiee"
                                  value={data.addressofthirdnomiee}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setAddressOf_third_nomineeError("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {AddressOf_third_nomineeError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <br />

                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Third Nominee Relationship with the members
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  options={OptionsFam}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  value={ThirdNomieeFamOptions}
                                  onChange={(e) => {
                                    setThirdNomieeOptFam(e);
                                    setThirdRelationError("");
                                    if (e != null && e != undefined) {
                                      setData({
                                        ...data,
                                        third_nominee_relationship: e.label,
                                      });
                                    }
                                  }}
                                />

                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {ThirdRelationError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Total Amount or Share of accumulations in
                                  Provident Fund to be paid to each nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>

                                <Select
                                  options={
                                    totalAmountSelect?.value ||
                                    TotalNomiees?.value ||
                                    ThirdNomieeOptions?.value ||
                                    fourtheNomie?.value
                                      ? getFilteredOptions(
                                          ThirdNomieeOptions.value,
                                        )
                                      : OptionsForNomiees
                                  }
                                  // options={ThirdNomieeOptions.value ? getFilteredOptions (ThirdNomieeOptions.value): OptionsForNomiees}
                                  name="third_total_amount"
                                  value={ThirdNomieeOptions}
                                  isDisabled={
                                    data.total_amount == 100 ||
                                    data.second_total_amount == 100 ||
                                    data.fourth_total_amount == 100
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleTotalAmounts(e, 2);
                                    setIfThirdTotalError("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {ifThirdTotalError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-4">
                                <br />
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Third Nominee Date Of Birth
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="date"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  max={today} // Set the max attribute to today's date
                                  name="third_nominee_dob"
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setThird_nominee_dobError("");
                                  }}
                                  value={data.third_nominee_dob}
                                  onKeyDown={preventTyping}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {third_nominee_dobError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-4">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  If the Third Nominee is a minor, name and
                                  address of the guardian who may receive the
                                  amount during the minority of the nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="third_if_nominee_minor"
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setIfThirdError("");
                                  }}
                                  value={data.third_if_nominee_minor}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {ifThirdError}
                                </p>
                              </div>
                              <div className="col-6 mt-4 centerElement">
                                <label>
                                  {" "}
                                  Upload the picture for the third nominee
                                  {/* <span style={{ color: "red" }}>*</span> */}
                                  <small
                                    style={{
                                      color: "red",
                                      marginLeft: "12px",
                                      display: "block",
                                    }}
                                  >
                                    Note:Upload the picture, please. Verify that
                                    the file is in the JPG, JPEG, or PNG format
                                    and that its size is less than 10 MB.
                                  </small>
                                </label>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    gap: "10px",
                                    flexDirection: "column",
                                  }}
                                >
                                  {images[2] && (
                                    <img
                                      src={images[2]}
                                      alt="test2"
                                      style={{
                                        width: "198px",
                                        height: "153px",
                                        borderRadius: "12px",
                                        border: "4px solid #234492",
                                      }}
                                    />
                                  )}
                                  <div
                                    className="w-100 d-flex "
                                    style={{
                                      gap: "12px",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Button
                                      className="doctorupload"
                                      component="label"
                                      role={undefined}
                                      variant="contained"
                                      tabIndex={-1}
                                      sx={{
                                        backgroundColor: "#234492",
                                        fontSize: "11px !important",
                                        "&:hover": {
                                          backgroundColor: "#e74c3c",

                                          opacity: "0.8",
                                        },
                                      }}
                                      onChange={(e) => {
                                        setforindex(2);
                                        setNomieeThirdImageError("");
                                        handleFileChange(e, 2);
                                      }}
                                      style={{
                                        width: "fit-content",
                                        color: "#fff",
                                      }}
                                      disabled={
                                        state.NumberCounts.EmployeeFormFIll ==
                                        true
                                          ? false
                                          : state.NumberCounts
                                                .EmployeeFormFIll == false &&
                                              state.ClientBranchIDs.SUBROLE == 3
                                            ? false
                                            : true
                                      }
                                    >
                                      {images[2]
                                        ? "Update Image"
                                        : "Upload file"}

                                      <VisuallyHiddenInput
                                        type="file"
                                        ref={fileInputRef}
                                      />
                                    </Button>
                                    <Downloads_doc url={images[2]} />
                                  </div>
                                </div>
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {NomieeeThirdImageError}
                                </p>
                              </div>
                            </div>
                          </>
                        ) : null}

                        {/* ///--four ===nomieee */}
                        {inputFields.InputFieldsNum.includes(4) ? (
                          <>
                            <div
                              className=" btn  StatusList"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignContent: "center",
                                gap: "20px",
                              }}
                            >
                              <div
                                className="DeclineStatus"
                                onClick={(e) => {
                                  console.log(
                                    Numberoffields,
                                    "1928Numberoffields",
                                    inputFields.InputFieldsNum,
                                    state.NumberCounts.Editable,
                                    state.ClientBranchIDs.SUBROLE,
                                  );

                                  if (
                                    state.NumberCounts.Editable == 2 ||
                                    state.ClientBranchIDs.SUBROLE == 3
                                  ) {
                                    setFourthenomieeFam();

                                    setFourthenomiee({ value: 0, label: "0" });
                                    handleRemoveFieldsNumbers(4);

                                    setData({
                                      ...data,
                                      fourth_if_nominee_minor: null,
                                      fourth_nominee_dob: null,
                                      fourth_nominee_name_address: null,
                                      fourth_nominee_relationship: null,
                                      fourth_percentage: null,
                                      fourth_total_amount: null,
                                      NameoffourthNomirr: "",
                                      addressoffourthnomiee: "",
                                    });
                                    setPresentImages([
                                      Presentimages[0],
                                      Presentimages[1],
                                      Presentimages[2],
                                      null,
                                    ]);
                                  }
                                }}
                              >
                                <span>x</span>
                              </div>
                            </div>

                            <div className="row" style={{ marginTop: "10px" }}>
                              <div className="col-sm-3 mt-3">
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Name of Fourth Nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="NameoffourthNomirr"
                                  value={data.NameoffourthNomirr}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setFourthNomineesError("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {fourthNomineesErr}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Address of the Fourth nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="addressoffourthnomiee"
                                  value={data.addressoffourthnomiee}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setAddressOf_fourth_nomineeError("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {AddressOf_fourth_nomineeError}
                                </p>
                              </div>
                              <div className="col-sm-3 mt-3">
                                <br />

                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Fourth Nominee Relationship with the members
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  options={OptionsFam}
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  value={fourtheNomieFam}
                                  onChange={(e) => {
                                    setFourthenomieeFam(e);
                                    setFourthRelationError("");
                                    if (e != null && e != undefined) {
                                      setData({
                                        ...data,
                                        fourth_nominee_relationship: e.label,
                                      });
                                    }
                                  }}
                                />

                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {FourthRelationError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-3">
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Total Amount or Share of accumulations in
                                  Provident Fund to be paid to each nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>

                                <Select
                                  options={
                                    totalAmountSelect?.value ||
                                    TotalNomiees?.value ||
                                    ThirdNomieeOptions?.value ||
                                    fourtheNomie?.value
                                      ? getFilteredOptions(fourtheNomie.value)
                                      : OptionsForNomiees
                                  }
                                  name="second_total_amount"
                                  value={fourtheNomie}
                                  isDisabled={
                                    data.total_amount == 100 ||
                                    data.second_total_amount == 100 ||
                                    data.third_total_amount == 100 ||
                                    data.total_amount == 100
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleTotalAmounts(e, 3);
                                    setFourthTotalError("");
                                  }}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {FourthTotalError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-4">
                                <br />
                                <br />
                                <br />
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Fourth Nominee Date Of Birth
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="date"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  max={today} // Set the max attribute to today's date
                                  name="fourth_nominee_dob"
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onFocus={(e) => e.target.showPicker()} // Programmatically trigger the date picker on focus
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setFourth_nominee_dobError("");
                                  }}
                                  value={data.fourth_nominee_dob}
                                  onKeyDown={preventTyping}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {fourth_nominee_dobError}
                                </p>
                              </div>

                              <div className="col-sm-3 mt-4">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  If the Fourth Nominee is a minor, name and
                                  address of the guardian who may receive the
                                  amount during the minority of the nominee
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="fourth_if_nominee_minor"
                                  readOnly={
                                    state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setIfFourthError("");
                                  }}
                                  value={data.fourth_if_nominee_minor}
                                />
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {ifFourthError}
                                </p>
                              </div>
                              <div className="col-6 mt-4 centerElement">
                                <label>
                                  {" "}
                                  Upload the picture for the fourth nominee
                                  {/* <span style={{ color: "red" }}>*</span> */}
                                  <small
                                    style={{
                                      color: "red",
                                      marginLeft: "12px",
                                      display: "block",
                                    }}
                                  >
                                    Note:Upload the picture, please. Verify that
                                    the file is in the JPG, JPEG, or PNG format
                                    and that its size is less than 10 MB.
                                  </small>
                                </label>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    gap: "10px",
                                    flexDirection: "column",
                                  }}
                                >
                                  {images[3] && (
                                    <img
                                      src={images[3]}
                                      alt="test2"
                                      style={{
                                        width: "198px",
                                        height: "153px",
                                        borderRadius: "12px",
                                        border: "4px solid #234492",
                                      }}
                                    />
                                  )}
                                  <div
                                    className="w-100 d-flex "
                                    style={{
                                      gap: "12px",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Button
                                      className="doctorupload"
                                      component="label"
                                      role={undefined}
                                      variant="contained"
                                      tabIndex={-1}
                                      sx={{
                                        backgroundColor: "#234492",
                                        fontSize: "11px !important",
                                        "&:hover": {
                                          backgroundColor: "#e74c3c",

                                          opacity: "0.8",
                                        },
                                      }}
                                      style={{
                                        width: "fit-content",
                                        color: "#fff",
                                      }}
                                      disabled={
                                        state.NumberCounts.EmployeeFormFIll ==
                                        true
                                          ? false
                                          : state.NumberCounts
                                                .EmployeeFormFIll == false &&
                                              state.ClientBranchIDs.SUBROLE == 3
                                            ? false
                                            : true
                                      }
                                      onChange={(e) => {
                                        setforindex(3);
                                        handleFileChange(e, 3);
                                        setNomieeFourImageError("");
                                      }}
                                    >
                                      {images[3]
                                        ? "Update Image"
                                        : "Upload file"}

                                      <VisuallyHiddenInput
                                        type="file"
                                        ref={fileInputRef}
                                      />
                                    </Button>
                                    <Downloads_doc url={images[3]} />
                                  </div>
                                </div>
                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {NomieeeFourImageError}
                                </p>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                      <>
                        {state.ClientBranchIDs.SUBROLE == 3 ? (
                          <div
                            className="RoleButton"
                            style={{
                              display: "flex",
                              gap: "15px",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              padding: "0px 15px",
                              marginBottom: "20px",
                            }}
                          >
                            <button
                              class="btn ButtonCSS"
                              style={{ color: "#ffff", background: "#234492" }}
                              onClick={(e) => {
                                dispatch(SetActiveTabs(8));
                              }}
                            >
                              Previous
                            </button>

                            <button
                              class="btn ButtonCSS"
                              style={{
                                color: "#ffff",
                                background: "#234492",
                              }}
                              onClick={(e) => {
                                HandleNext(e);
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        ) : (
                          <>
                            {state.NumberCounts.EmployeeFormFIll != false &&
                            (state.NumberCounts.Editable == 2 ||
                              state.ClientBranchIDs.SUBROLE == 0 ||
                              state.ClientBranchIDs.SUBROLE == 1) ? (
                              <>
                                <div
                                  className="RoleButton"
                                  style={{
                                    display: "flex",
                                    gap: "15px",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    padding: "0px 15px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <button
                                    class="btn ButtonCSS"
                                    style={{
                                      color: "#ffff",
                                      background: "#234492",
                                    }}
                                    onClick={(e) => {
                                      dispatch(SetActiveTabs(8));
                                    }}
                                  >
                                    Previous
                                  </button>

                                  {/* {
                              state.pennydropforBank.BankVerify 
                              &&
                              state.NumberCounts.Editable != 1 &&
                              creaetStat
                               ? ( */}
                                  <button
                                    class="btn ButtonCSS"
                                    style={{
                                      color: "#ffff",
                                      background: "#234492",
                                    }}
                                    onClick={(e) => {
                                      HandleNext(e);
                                    }}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </>
                            ) : null}
                          </>
                        )}
                      </>

                      {/* <>
                        {state.NumberCounts.Editable == 1 &&
                          state.ClientBranchIDs.SUBROLE == 3 ? (
                          <>
                            {!state.ClientBranchIDs.StatusBtn &&
                              createEmployee ? (
                              <>
                                {Approvel ? (
                                  ///----Approved--Employee-----------------
                                  <div
                                    className="col-12 VerficationStatus IdVerificationsID"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-end",
                                    }}
                                  >

                                    <span style={{ color: "#234492" }}>
                                      Approved Employee
                                    </span>
                                  </div>
                                ) : (
                                  <>
                                    {!whatsApp ||
                                      (SubRoleList != 0 &&
                                        state.ClientBranchIDs.SUBROLE == 3) ||
                                      (createEmployee &&
                                        state.NumberCounts.Editable == 1) ? (
                                      <div
                                        className="col-12 VerficationStatus"
                                        style={{
                                          marginTop: "10px",
                                          marginBottom: "30px",
                                        }}
                                      >
                                        <button
                                          className="Decline ButtonCSS"
                                          onClick={(e) => {
                                            HandleDecline(e);
                                          }}
                                        >
                                          Reject
                                        </button>
                                        <button
                                          className="verify ButtonCSS"
                                          onClick={(e) => {
                                            HandleVerify(e);
                                          }}
                                        >
                                          Approve
                                        </button>
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </>
                            ) : null}

                          </>
                        ) : null}
                      </> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={Educatiobnfiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};

export default ESIfrom;
